/**
 * Chart module
 * @param config for user configuration (i.e. size)
 * @todo polish tooltips && its styles
 *
 * Only Bars, Scatter & Timeline use chartmodule for axes
 */

//var d3Tip = require('d3-tip');
//var d3 = require('d3');
//var _ = require('lodash');
import d3Tip from "d3-tip";
import * as _ from "lodash";
import * as d3 from "d3";

class chartModule {
  _config = undefined;
  defaultConfig = undefined;
  _data = [];
  _margin = undefined;
  _width = undefined;
  _height = undefined;
  _svg = undefined;
  _scales = {
    x: undefined,
    y: undefined,
    color: undefined
  };
  _axes = {
    x: undefined,
    y: undefined
  };
  _xAxis = undefined;
  _yAxis = undefined;
  defaultStyle = undefined;
  layers = undefined;
  helper = undefined;
  _addStyle = undefined;
  dispatch = d3.dispatch("load", "change");
  _fullSvg = undefined;

  constructor() {
    const vm = this;

    const defaultConfig = {
      size: {
        width: 800,
        height: 600,
        margin: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      }
    };

    vm._config = defaultConfig;
    vm._data = [];
    vm._margin = vm._config.size.margin;
    // Define width and height
    vm._width = vm._config.size.width - vm._margin.left - vm._margin.right;
    vm._height = vm._config.size.height - vm._margin.top - vm._margin.bottom;
    vm._svg = "";

    vm.defaultStyle = {
      chart: {
        backgroundColor: {
          color: "transparent"
        }
      },
      title: {
        textColor: "#E6B537",
        fontSize: "30px",
        fontWeight: 600,
        textAlign: "center",
        hr: {
          enabled: true,
          borderWidth: "1px",
          borderColor: "#fff"
        }
      },
      legend: {
        position: "right",
        figure: "circle",
        text: {
          textColor: "#5F6C6C",
          fontSize: "12px",
          fontWeight: 600
        },
        title: {
          textColor: "#5F6C6C",
          fontSize: "12px",
          fontWeight: 600
        }
      },
      tooltip: {
        backgroundColor: "#757575",
        opacity: 0.8,
        text: {
          textColor: "#fff",
          fontSize: "12px",
          fontWeight: 600,
          textAlign: "center",
          fontFamily: "sans-serif",
          padding: "0.8em"
        },
        border: {
          color: "#fff",
          radius: "5px",
          width: "0px"
        }
      },
      yAxis: {
        enabled: true,
        axis: {
          strokeWidth: 3,
          strokeColor: "#5F6C6C",
          strokeOpacity: 0,
          paddingTick: 0
        },
        ticks: {
          strokeWidth: 3,
          strokeColor: "#F4F3F3",
          line: "dashed",
          grid: true,
          gridDashed: "3, 5",
          opacity: 0.6,
          ysize: 6
        },
        labels: {
          fontSize: "13px",
          fontWeight: 600,
          textColor: "#666666",
          textAnchor: "end",
          rotation: 0,
          padding: 0
        },
        title: {
          fontSize: "17px",
          fontWeight: 600,
          textColor: "#666666",
          textAnchor: "middle",
          rotation: 0
          // text align or position
        }
      },
      xAxis: {
        enabled: true,
        axis: {
          strokeWidth: 3,
          strokeColor: "#5F6C6C",
          strokeOpacity: 1,
          paddingTick: 7
        },
        ticks: {
          strokeWidth: 1,
          strokeColor: "#F4F3F3",
          opacity: 0,
          size: 6,
          grid: false,
          line: "dashed",
          gridDashed: "3, 5",
          xsize: 6
        },
        labels: {
          fontSize: "13px",
          fontWeight: 500,
          textColor: "#666666",
          textAnchor: "middle",
          rotation: 0,
          padding: 7
        },
        title: {
          fontSize: "17px",
          fontWeight: 600,
          textColor: "#666666",
          textAnchor: "middle",
          rotation: 0
          // text align
        }
      },
      labels: {
        fontSize: "17px",
        fontWeight: 600,
        textColor: "#fff",
        textAnchor: "start",
        rotation: 0
      }
    };
    vm._addStyle = vm.defaultStyle;

    // Public
    vm.layers = [];

    // Helper data/functions for layers to use
    vm.helper = Helper.bind(vm)();
  }

  /**
   * User config functions
   */

  // set config
  config(config) {
    var vm = this;
    vm._config = _.cloneDeep(config);
    vm._margin = vm._config.size.margin;
    vm._width = vm._config.size.width - vm._margin.left - vm._margin.right;
    vm._height = vm._config.size.height - vm._margin.top - vm._margin.bottom;

    vm.helper = Helper.bind(vm)();
    return vm;
  }

  // set element where chart will be created
  bindTo(selector) {
    var vm = this;
    vm._config.bindTo = selector;
    return vm;
  }

  // set data
  data(data) {
    var vm = this;
    if (vm._config.data !== undefined) {
      vm._config.data = Object.assign({}, vm._config.data, data);
    } else {
      vm._config.data = data;
    }
    return vm;
  }

  // set style config
  addStyle(stylesObj) {
    var vm = this;
    if (stylesObj) {
      _.merge(vm._addStyle, stylesObj);
    }
    return vm;
  }

  // add layer
  layer(_layer) {
    var vm = this;
    var layer;
    var config = vm._config;
    if (_layer !== undefined && _layer !== null) {
      switch (_layer) {
        case "bars":
          layer = bars(config, vm.helper);
          vm.layers = layer;
          break;
        case "scatter":
          layer = scatter(config, vm.helper);
          vm.layers = layer;
          break;
        case "timeline":
          layer = timeline(config, vm.helper);
          vm.layers = layer;
          break;
        case "treemap":
          layer = treemap(config, vm.helper);
          vm.layers = layer;
          break;
        case "spineplot":
          layer = spineplot(config, vm.helper);
          vm.layers = layer;
          break;
        case "heatmap":
          layer = heatmap(config, vm.helper);
          vm.layers = layer;
          break;
      }
      return layer;
    }
  }

  // set legend
  legend(legend) {
    var vm = this;
    vm._config.legend = legend;
    return vm;
  }

  // type checkbox for legend filters
  legendType(legendType) {
    var vm = this;
    vm._config.legendType = legendType;
    return vm;
  }

  // set title for legend
  legendTitle(legendTitle) {
    var vm = this;
    vm._config.legendTitle = legendTitle;
    return vm;
  }

  // draw chart & layer
  draw() {
    var vm = this;
    var q;

    vm._scales = vm.scales();
    q = vm.loadData();

    q.awaitAll(function(error, results) {
      if (error) throw error;

      if (Array.isArray(results) && results.length == 1) {
        vm._data = results[0];
      } else {
        vm._data = results;
      }

      vm.initLayers();

      vm.drawSVG();

      vm._axes = vm.axes();
      vm.drawAxes();

      vm.drawLayers();

      //Trigger load chart event
      if (vm._config.events && vm._config.events.load) {
        vm.dispatch.on("load.chart", vm._config.events.load(vm));
      }
    });
    return vm;
  }

  /**
   * Internal methods
   */

  // callback for raw data
  mapData(data, callback) {
    callback(null, data);
  }

  // call data
  loadData() {
    var vm = this;
    var q;

    if (vm._config.data.tsv) {
      q = d3.queue().defer(d3.tsv, vm._config.data.tsv);
    }

    if (vm._config.data.json) {
      q = d3.queue().defer(d3.json, vm._config.data.json);
    }

    if (vm._config.data.csv) {
      q = d3.queue().defer(d3.csv, vm._config.data.csv);
    }

    if (vm._config.data.raw) {
      q = d3.queue().defer(vm.mapData, vm._config.data.raw);
    }

    /* if (vm._config.data.cartodb) {
      q = d3.queue().defer(carto.query, vm._config.data);
    } */

    if (
      vm._config.map &&
      vm._config.map.topojson &&
      vm._config.map.topojson.url
    ) {
      q.defer(d3.json, vm._config.map.topojson.url);
    }

    /* if (vm._config.plotOptions && vm._config.plotOptions.bars && vm._config.plotOptions.bars.averageLines && Array.isArray(vm._config.plotOptions.bars.averageLines) && vm._config.plotOptions.bars.averageLines.length > 0) {

      vm._config.plotOptions.bars.averageLines.forEach(function (l) {
        if (l.data.cartodb) {
          q.defer(carto.query, l.data);
        }
      });
    } */

    return q;
  }

  // create the g element to draw chart
  drawSVG() {
    var vm = this;

    //Remove any previous svg or html content
    d3.select(vm._config.bindTo).html("");
    d3.select(vm._config.bindTo)
      .select("svg")
      .remove();

    //Create the svg
    vm._fullSvg = d3
      .select(vm._config.bindTo)
      .append("svg")
      .style(
        "font-size",
        vm._config.chart
          ? vm._config.chart["font-size"]
            ? vm._config.chart["font-size"]
            : "12px"
          : "12px"
      )
      .attr("width", vm._width + vm._margin.left + vm._margin.right)
      .attr("height", vm._height + vm._margin.top + vm._margin.bottom);

    vm._svg = vm._fullSvg
      .append("g")
      .attr(
        "transform",
        "translate(" + vm._margin.left + "," + vm._margin.top + ")"
      );

    if (vm._config.hasOwnProperty("legend")) {
      vm.drawLegend();
    }
  }

  // set axes scales
  scales() {
    var vm = this;

    var scales = {
      x: undefined,
      q: undefined,
      y: undefined,
      color: undefined
    };
    // xAxis scale
    if (vm._config.xAxis && vm._config.xAxis.scale) {
      switch (vm._config.xAxis.scale) {
        case "linear":
          scales.x = d3.scaleLinear().range([0, vm._width]);
          break;

        case "time":
          scales.x = d3.scaleTime().range([0, vm._width]);
          break;

        case "ordinal":
          scales.x = d3.scalePoint().range([0, vm._width]);
          break;

        case "band":
          scales.x = d3
            .scaleBand()
            .rangeRound([0, vm._width])
            .padding(0.1);
          break;

        case "quantile":
          scales.x = d3.scalePoint().range([0, vm._width]);

          scales.q = d3
            .scaleQuantile()
            .range(d3.range(vm._config.xAxis.buckets));
          break;

        default:
          scales.x = d3.scaleLinear().range([0, vm._width]);
          break;
      }
    } else {
      scales.x = d3.scaleLinear().range([0, vm._width]);
    }

    //yAxis scale
    if (vm._config.yAxis && vm._config.yAxis.scale) {
      switch (vm._config.yAxis.scale) {
        case "linear":
          scales.y = d3.scaleLinear().range([vm._height, 0]);
          break;

        case "time":
          scales.y = d3.scaleTime().range([vm._height, 0]);
          break;

        case "ordinal":
          scales.y = d3.scalePoint().range([vm._height, 0]);
          break;

        case "band":
          scales.y = d3
            .scaleBand()
            .rangeRound([vm._height, 0])
            .padding(0.1);
          break;

        case "quantile":
          scales.y = d3.scalePoint().range([0, vm._width]);

          scales.q = d3
            .scaleQuantile()
            .range(d3.range(vm._config.yAxis.buckets));
          break;

        default:
          scales.y = d3.scaleLinear().range([vm._height, 0]);
          break;
      }
    } else {
      scales.y = d3.scaleLinear().range([vm._height, 0]);
    }

    scales.color = d3.scaleOrdinal(d3.schemeCategory10);

    return scales;
  }

  // set axes
  axes() {
    var vm = this;
    var axes = {
      x: d3.axisBottom(vm._scales.x),
      y: d3.axisLeft(vm._scales.y)
    };

    //remove corners in axis line
    axes.x.tickSizeOuter(0);
    axes.y.tickSizeOuter(0);

    // set x axis ticks
    if (
      vm._config.xAxis &&
      vm._config.xAxis.ticks &&
      vm._config.xAxis.ticks.values
    ) {
      axes.x.tickValues(vm._config.xAxis.ticks.values);
    }

    // format ticks
    if (
      vm._config.xAxis &&
      vm._config.xAxis.ticks &&
      vm._config.xAxis.ticks.format
    ) {
      axes.x.tickFormat(vm._config.xAxis.ticks.format);
    }

    if (
      vm._config.yAxis &&
      vm._config.yAxis.ticks &&
      vm._config.yAxis.ticks.format
    ) {
      axes.y.tickFormat(vm._config.yAxis.ticks.format);
    }

    return axes;
  }

  // draw axes
  drawAxes() {
    var vm = this;
    var yAxis;

    //Axes tooltip
    var axesTip = vm.helper.utils.d3.tip().html(function(d) {
      return '<div class="title-tip">' + d + "</div>";
    });

    if (
      (!vm._config.yAxis ||
        (vm._config.yAxis && vm._config.yAxis.enabled !== false)) &&
      (!vm._config.xAxis ||
        (vm._config.xAxis && vm._config.xAxis.enabled !== false))
    ) {
      vm._svg.call(axesTip);
    }

    /**
     * Config axes
     */

    // y
    if (
      !vm._config.yAxis ||
      (vm._config.yAxis && vm._config.yAxis.enabled !== false)
    ) {
      // draw axis
      yAxis = vm._svg
        .append("g")
        .attr("class", "y axis")
        .call(vm._axes.y);
      // add axis title
      if (vm._config.yAxis && vm._config.yAxis.text) {
        yAxis
          .append("text")
          .attr("class", "axis-title")
          .attr("y", -vm._margin.left * 0.7)
          .attr("x", -vm._height / 2)
          .attr("transform", "rotate(-90)")
          .attr("text-anchor", "middle")
          .text("vm._config.yAxis.text");
      }
    }

    // custom display domain and or ticks
    if (
      vm._config.yAxis &&
      vm._config.yAxis.domain &&
      vm._config.yAxis.domain.hasOwnProperty("enabled")
    ) {
      if (vm._config.yAxis.ticks) {
        if (
          vm._config.yAxis.domain.enabled === false &&
          vm._config.yAxis.ticks.enabled === false
        ) {
          d3.select("g.y.axis .domain").remove();
          d3.selectAll("g.y.axis .tick").remove();
        } else if (
          vm._config.yAxis.domain.enabled === false &&
          vm._config.yAxis.ticks.enabled === true
        ) {
          d3.select("g.y.axis .domain").remove();
        }
      } else {
        if (vm._config.yAxis.domain.enabled === false) {
          d3.select("g.y.axis .domain").remove();
          d3.selectAll("g.y.axis .tick").remove();
        }
      }
    }

    // style y axis
    if (vm._config.yAxis.enabled !== false) {
      //axis line
      yAxis
        .selectAll(".domain")
        .attr("stroke-linecap", "round")
        .attr("stroke-width", vm._addStyle.yAxis.axis.strokeWidth)
        .attr("stroke", vm._addStyle.yAxis.axis.strokeColor)
        .attr("opacity", vm._addStyle.yAxis.axis.strokeOpacity);

      //axis title
      yAxis
        .selectAll(".axis-title")
        .attr("font-size", vm._addStyle.yAxis.title.fontSize)
        .attr("font-weight", vm._addStyle.yAxis.title.fontWeight)
        .attr("fill", vm._addStyle.yAxis.title.textColor)
        .attr("text-anchor", vm._addStyle.yAxis.title.textAnchor);

      //tick lines
      yAxis
        .selectAll(".tick line")
        .attr("stroke-width", vm._addStyle.yAxis.ticks.strokeWidth)
        .attr("stroke", vm._addStyle.yAxis.ticks.strokeColor)
        .attr("stroke-opacity", vm._addStyle.yAxis.ticks.opacity);
      // set tick lines as tick or grids
      if (vm._addStyle.yAxis.ticks.grid)
        yAxis.selectAll(".tick line").attr("x2", vm._width);
      else
        yAxis
          .selectAll(".tick line")
          .attr("x2", vm._addStyle.yAxis.ticks.ysize);

      //don't draw first tick when line is dashed
      if (
        !vm._addStyle.yAxis.ticks.line ||
        vm._addStyle.yAxis.ticks.line == "dashed"
      ) {
        //condition gridline
        yAxis
          .selectAll(".tick line")
          .attr("stroke-dasharray", vm._addStyle.yAxis.ticks.gridDashed)
          .attr(
            "transform",
            "translate(-" + vm._addStyle.yAxis.axis.paddingTick + ", 0)"
          );
        yAxis
          .selectAll(".tick:first-of-type line:first-of-type")
          .attr("stroke", "none");
      }

      //tick text
      yAxis
        .selectAll(".tick text")
        .attr("font-size", vm._addStyle.yAxis.labels.fontSize)
        .attr("font-weight", vm._addStyle.yAxis.labels.fontWeight)
        .attr("fill", vm._addStyle.yAxis.labels.textColor)
        .attr("text-anchor", vm._addStyle.yAxis.labels.textAnchor)
        .attr(
          "transform",
          "translate(-" +
            vm._addStyle.yAxis.labels.padding +
            ", 0)rotate(" +
            vm._addStyle.yAxis.labels.rotation +
            ")"
        )
        .attr("opacity", function(d) {
          return Number.isInteger(d) ? 1 : 0;
        });

      // Add ellipsis to cut label text when too long
      // for yAxis on the left
      yAxis.selectAll(".tick text").each(function(d) {
        var element = this;
        if (typeof d === "string") {
          if (element.getComputedTextLength() > 0.8 * vm._margin.left) {
            (function() {
              d3.select(element)
                .on("mouseover", axesTip.show)
                .on("mouseout", axesTip.hide);
              var i = 1;
              while (element.getComputedTextLength() > 0.8 * vm._margin.left) {
                d3.select(element)
                  .text(function(d) {
                    return d.slice(0, -i) + "...";
                  })
                  .attr("title", d);
                ++i;
              }
            })();
          } else {
            return d;
          }
        }
      });
    }

    // y

    /////////////////////////////

    // x

    if (
      !vm._config.xAxis ||
      (vm._config.xAxis && vm._config.xAxis.enabled !== false)
    ) {
      // draw axis
      vm._xAxis = vm._svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + vm._height + ")")
        .call(vm._axes.x);

      // set axis title
      if (vm._config.xAxis && vm._config.xAxis.text) {
        vm._xAxis
          .append("text")
          .attr("class", "axis-title")
          .attr("x", vm._width / 2)
          .attr("y", 40)
          .style("text-anchor", "middle")
          .text(vm._config.xAxis.text);
      }

      //Do not show line if axis is disabled
      if (
        vm._config.xAxis &&
        vm._config.xAxis.line &&
        vm._config.xAxis.line.enabled == false
      ) {
        vm._xAxis.selectAll("path").remove();
      }

      //Disable ticks when set to false
      if (
        vm._config.xAxis &&
        vm._config.xAxis.ticks &&
        vm._config.xAxis.ticks.line &&
        vm._config.xAxis.ticks.line.enabled === false
      ) {
        vm._xAxis.selectAll("line").remove();
      }
    }

    // custom display domain and or ticks
    if (
      vm._config.xAxis &&
      vm._config.xAxis.domain !== undefined &&
      vm._config.xAxis.domain.hasOwnProperty("enabled")
    ) {
      if (vm._config.xAxis.ticks) {
        if (
          vm._config.xAxis.domain.enabled === false &&
          vm._config.xAxis.ticks.enabled === false
        ) {
          d3.select(vm._config.bindTo + " g.x.axis .domain").remove();
          d3.selectAll("g.x.axis .tick").remove();
        } else if (vm._config.xAxis.ticks.enabled === false) {
          d3.select(vm._config.bindTo + " g.x.axis .domain").remove();
        }
      } else {
        if (vm._config.xAxis.domain.enabled === false) {
          d3.select(vm._config.bindTo + " g.x.axis .domain").remove();
          d3.selectAll(vm._config.bindTo + " g.x.axis .tick").remove();
        }
      }
    }

    if (vm._config.xAxis.ticks.enabled === false) {
      d3.selectAll("g.x.axis .tick").remove();
    }

    //Style X axis
    if (vm._config.xAxis.enabled !== false) {
      //axis line
      vm._xAxis
        .selectAll(".domain")
        .attr("stroke-linecap", "round")
        .attr("stroke-width", vm._addStyle.xAxis.axis.strokeWidth)
        .attr("stroke", vm._addStyle.xAxis.axis.strokeColor)
        .attr("opacity", vm._addStyle.xAxis.axis.strokeOpacity);

      //axis title
      vm._xAxis
        .selectAll(".axis-title")
        .attr("font-size", vm._addStyle.xAxis.title.fontSize)
        .attr("font-weight", vm._addStyle.xAxis.title.fontWeight)
        .attr("fill", vm._addStyle.xAxis.title.textColor)
        .attr("text-anchor", vm._addStyle.xAxis.title.textAnchor)
        .attr(
          "transform",
          "translate(0, " +
            vm._addStyle.xAxis.axis.paddingTick +
            ")rotate(" +
            vm._addStyle.xAxis.title.rotation +
            ")"
        );

      //tick lines
      vm._xAxis
        .selectAll(".tick line")
        .attr("stroke-width", vm._addStyle.xAxis.ticks.strokeWidth)
        .attr("stroke", vm._addStyle.xAxis.ticks.strokeColor)
        .attr(
          "transform",
          "translate(0, " + vm._addStyle.xAxis.axis.paddingTick + ")"
        );

      // set tick lines as tick or grids
      if (vm._addStyle.xAxis.ticks.grid)
        vm._xAxis.selectAll(".tick line").attr("x2", vm._height);
      else
        vm._xAxis
          .selectAll(".tick line")
          .attr("x2", vm._addStyle.xAxis.ticks.xsize);

      //don't draw first tick when line is dashed
      if (
        !vm._addStyle.xAxis.ticks.li098ne ||
        vm._addStyle.xAxis.ticks.line == "dashed"
      ) {
        vm._xAxis
          .selectAll(".tick:first-of-type line:first-of-type")
          .attr("stroke", "none");
      }

      //tick text
      vm._xAxis
        .selectAll(".tick text")
        .attr("font-size", vm._addStyle.xAxis.labels.fontSize)
        .attr("font-weight", vm._addStyle.xAxis.labels.fontWeight)
        .attr("fill", vm._addStyle.xAxis.labels.textColor)
        .attr("text-anchor", vm._addStyle.xAxis.labels.textAnchor)
        .attr(
          "transform",
          "translate(0, " +
            vm._addStyle.xAxis.labels.padding +
            ")rotate(" +
            vm._addStyle.xAxis.labels.rotation +
            ")"
        );

      /* check the case for timeline
      var barMinWidth = d3.min(vm._svg.selectAll('rect.bar').nodes(), function (node) {
        return node.getAttribute("width");
      });  */

      var largestLabelWidth = d3.max(
        vm._xAxis.selectAll(".tick text").nodes(),
        function(node) {
          return node.getComputedTextLength();
        }
      );

      // if bars
      if (typeof vm._scales.x.bandwidth != "undefined") {
        d3.select(".x.axis")
          .selectAll("text")
          .nodes()
          .map(function(el) {
            // element, current width, max width, max label width
            vm.helper.utils.labels(
              el,
              vm._scales.x.bandwidth(),
              vm._scales.x.bandwidth(),
              largestLabelWidth
            );
          });
      }
    }
  }

  // call layers scales
  initLayers() {
    var vm = this;
    vm.layers.data(vm._data).scales();
    vm._scales = vm.layers._scales;
  }

  // call draw method of layer
  drawLayers() {
    var vm = this;
    vm.layers.draw();
  }

  drawLegend() {
    var vm = this;

    var legendTip = vm.helper.utils.d3.tip().html(function(d) {
      return '<div class="title-tip">' + (d.name || d) + "</div>";
    });
    vm._fullSvg.call(legendTip);
    var legendBox;
    // Draw legend, defaults to right
    if (vm._addStyle && vm._addStyle.legend.position === "bottom") {
      legendBox = vm._fullSvg
        .append("g")
        .attr("class", "legendBox")
        .attr("width", vm._width)
        .attr(
          "transform",
          "translate(" +
            vm._config.size.margin.left +
            "," +
            (vm._config.size.height - 30) +
            ")"
        );
    } else {
      legendBox = vm._fullSvg
        .append("g")
        .attr("class", "legendBox")
        .attr(
          "transform",
          "translate(" +
            (vm._config.size.width - vm._config.size.margin.right + 5) +
            "," +
            1 * 19 +
            ")"
        );
    }

    if (vm._config.legendTitle) {
      legendBox
        .append("text")
        .attr("class", "legend-title")
        .text(vm._config.legendTitle);

      //wrap legend title if text size exceeds 70% of container
      var lWidth = vm._config.size.margin.right;
      var text = d3.selectAll(".legend-title"),
        words = text
          .text()
          .split(/\s+/)
          .reverse(),
        word,
        line = [],
        lineNumber = 1,
        lineHeight = 1.1,
        // ems
        y = text.attr("y"),
        dy = 0,
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > lWidth) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          ++lineNumber;
          tspan = text
            .append("tspan")
            .attr("x", 0)
            .attr("y", y)
            .attr("dy", lineHeight + "em")
            .text(word);
        }
      }
      d3.selectAll(".legend-title tspan")
        .attr("fill", vm._addStyle.legend.title.textColor)
        .style("font-size", vm._addStyle.legend.title.fontSize)
        .style("font-weight", vm._addStyle.legend.title.fontWeight);
    }

    var lbWidth = vm._config.size.margin.right * 0.8;

    if (vm._config.legendType === "checkbox") {
      var size = 18,
        x = 0,
        _y = 0,
        rx = 2,
        ry = 2,
        markStrokeWidth = 3;

      vm._scales.color.domain(
        vm._config.legend.map(function(o) {
          return o.name;
        })
      );

      var legendCheck = legendBox
        .selectAll(".legend-checkbox")
        .data(vm._config.legend)
        .enter()
        .append("g")
        .attr("class", ".legend-checkbox legend")
        .attr("transform", function(d, i) {
          return (
            "translate(0," +
            (vm._config.legendTitle && lineNumber > 1
              ? lineNumber * lineHeight + i
              : 1 + i) *
              20 +
            ")"
          );
        })
        .on("click", function(d, i) {
          // Run the custom function
          if (typeof vm._config.events.onClickLegend === "function") {
            vm._config.events.onClickLegend.call(this, d, i);
          }
          d3.event.stopPropagation();
        });

      legendCheck
        .append("rect")
        .attr("width", size)
        .attr("height", size)
        .attr("x", x)
        .attr("rx", rx)
        .attr("ry", ry)
        .attr("fill-opacity", 1)
        .attr("fill", function(d) {
          return vm._scales.color(d.name);
        });

      var coordinates;
      coordinates = [
        {
          x: x + size / 8,
          y: _y + size / 2
        },
        {
          x: x + size / 2.2,
          y: _y + size - size / 4
        },
        {
          x: x + size - size / 8,
          y: _y + size / 10
        }
      ];

      var _line = d3
        .line()
        .x(function(d) {
          return d.x;
        })
        .y(function(d) {
          return d.y;
        });

      // mark
      legendCheck
        .append("path")
        .attr("d", _line(coordinates))
        .attr("stroke-width", markStrokeWidth)
        .attr("stroke", "white")
        .attr("fill", "none")
        .attr("class", "mark")
        .property("checked", function(d) {
          // External function call. It must be after all the internal code; allowing the user to overide
          return d.active;
        })
        .attr("opacity", function() {
          if (d3.select(this).property("checked")) {
            return 1;
          } else {
            return 0;
          }
        });

      legendCheck
        .append("text")
        .attr("class", "labelText")
        .attr("x", 20)
        .attr("y", 9)
        .attr("dy", ".35em")
        .attr("text-anchor", "start")
        .text(function(d) {
          //External function call. It must be after all the internal code; allowing the user to overide
          return d.name;
        });

      //cut label text if text size exceeds 80% of container
      legendCheck.selectAll("text").each(function(d) {
        var _this = this;

        if (typeof d.name === "string") {
          if (this.getComputedTextLength() > lbWidth) {
            (function() {
              d3.select(_this)
                .attr("title", d.name)
                .on("mouseover", legendTip.show)
                .on("mouseout", legendTip.hide);
              var i = 1;
              while (_this.getComputedTextLength() > lbWidth) {
                d3.select(_this).text(function(d) {
                  return d["name"].slice(0, -i) + "...";
                });
                ++i;
              }
            })();
          } else {
            return d;
          }
        }
      });
    } else {
      var legend;
      if (vm._config._addStyle && vm._addStyle.legend.position === "bottom") {
        legend = legendBox
          .selectAll(".legend")
          .data(vm._config.legend)
          .enter()
          .append("g")
          .attr("class", "legend")
          .attr("width", vm._width / (vm._config.legend.length + 1))
          .attr("transform", function(d, i) {
            //horizontal position
            //what if there are too many legends?
            return (
              "translate(" +
              (vm._width / (vm._config.legend.length + 1)) * i +
              "," +
              (vm._config.legendTitle && lineNumber > 1
                ? lineNumber * lineHeight
                : 0) *
                19 +
              ")"
            );
          });
      } else {
        legend = legendBox
          .selectAll(".legend")
          .data(vm._config.legend)
          .enter()
          .append("g")
          .attr("class", "legend")
          .attr("transform", function(d, i) {
            return (
              "translate(" +
              5 +
              "," +
              (vm._config.legendTitle && lineNumber > 1
                ? lineNumber * lineHeight + i
                : 1 + i) *
                19 +
              ")"
            );
          });
      }

      if (vm._addStyle.legend.figure === "circle") {
        legend
          .append("circle")
          .attr("cx", 2)
          .attr("cy", 9)
          .attr("r", 7)
          .attr("stroke-width", 2)
          .attr("stroke", function(d) {
            return vm._scales.color(d.name);
          })
          .attr("fill", function(d) {
            return vm._scales.color(d.name);
          })
          .attr("fill-opacity", 0.8);
      } else {
        legend
          .append("rect")
          .attr("x", 0)
          .attr("width", 18)
          .attr("height", 18)
          .attr("fill", function(d) {
            return vm._scales.color(d.name);
          });
      }

      legend
        .append("text")
        .attr("x", 20)
        .attr("y", 9)
        .attr("dy", ".35em")
        .attr("text-anchor", "start")
        .text(function(d) {
          //External function call. It must be after all the internal code; allowing the user to overide
          return d.name;
        });

      //cut label text if text size exceeds 80% of container
      var _lbWidth = vm._config.size.margin.right - 19;
      legend.selectAll("text").each(function(d) {
        var _this2 = this;

        if (typeof d.name === "string") {
          if (this.getComputedTextLength() > _lbWidth) {
            (function() {
              d3.select(_this2)
                .attr("title", d.name)
                .on("mouseover", legendTip.show)
                .on("mouseout", legendTip.hide);
              var i = 1;
              while (_this2.getComputedTextLength() > _lbWidth) {
                d3.select(_this2).text(function(d) {
                  return d["name"].slice(0, -i) + "...";
                });
                ++i;
              }
            })();
          } else {
            return d;
          }
        }
      });
    }

    /**
     * Give some extra style
     */

    legendBox
      .selectAll(".legend text")
      .attr("fill", vm._addStyle.legend.text.textColor)
      .attr("font-size", vm._addStyle.legend.text.fontSize)
      .attr("font-weight", vm._addStyle.legend.text.fontWeight);
  }
}

function Helper() {
  var vm = this; // Hard binded to chart
  var Helper = {
    chart: {
      config: vm._config,
      width: vm._width,
      height: vm._height,
      style: vm._addStyle,
      fullSvg: function fullSvg() {
        return vm._fullSvg;
      },
      svg: function svg() {
        return vm._svg;
      }
    },
    utils: {
      d3: {
        tip: undefined
      },
      generateScale: undefined,
      format: undefined,
      wrap: undefined,
      labels: undefined,
      sortAscending: undefined,
      sortDescending: undefined
    }
  };

  Helper.utils.d3.tip = d3Tip;

  Helper.utils.generateScale = function(data, config) {
    var scale = {};
    var domains;
    if (!config.range) {
      throw "Range is not defined";
    }
    // Used in bars.js when we want to create a groupBy or stackBy bar chart
    if (config.groupBy && config.groupBy == "parent") {
      // Axis of type band
      domains = data.map(function(d) {
        return d[config.column];
      });
    } else if (config.stackBy && config.stackBy == "parent") {
      domains = data[0].map(function(d) {
        return d.data[config.column];
      });
    } else if (config.groupBy == "children") {
      // GroupBy Columns
      domains = config.column;
    } else if (config.groupBy == "data") {
      // Considering the highest value on all the columns for each groupBy column
      domains = [
        0,
        d3.max(data, function(d) {
          return d3.max(config.column, function(column) {
            return d[column];
          });
        })
      ];
    } else if (config.stackBy == "data") {
      // Using a d3.stack()
      domains = [
        0,
        d3.max(data, function(serie) {
          return d3.max(serie, function(d) {
            return d[1];
          });
        })
      ];
    } else if (config.groupBy == undefined && config.type == "band") {
      // In case the axis is of type band and there is no groupby
      domains = data.map(function(d) {
        return d[config.column];
      });
    } else if (config.type === "linear") {
      // Axis of type numeric
      domains = d3.extent(data, function(d) {
        return +d[config.column];
      });
    } else {
      // Axis of type band
      domains = data.map(function(d) {
        return d[config.column];
      });
    }

    if (config.minZero) {
      domains = [
        0,
        d3.max(data, function(d) {
          return +d[config.column];
        })
      ];
    }
    if (config.domains && Array.isArray(config.domains)) {
      domains = config.domains;
    }

    if (config.type) {
      switch (config.type) {
        case "linear":
          scale = d3
            .scaleLinear()
            .rangeRound(config.range)
            .domain(domains)
            .nice();
          break;

        case "time":
          scale = d3.scaleTime().range(config.range);
          // .domain(domains);
          break;

        case "ordinal":
          scale = d3
            .scaleBand()
            .rangeRound(config.range)
            .padding(0.1)
            .domain(domains);
          break;

        case "band":
          scale = d3
            .scaleBand()
            .rangeRound(config.range)
            .domain(domains)
            .padding(0.1);
          break;

        case "quantile":
          scale = d3
            .scaleBand()
            .rangeRound(config.range)
            .padding(0.1)
            .domain(
              data.map(function(d) {
                return d[config.column];
              })
            );
          if (!config.bins) {
            config.bins = 10;
          }
          scale = d3.scaleQuantile().range(d3.range(config.bins));
          break;

        default:
          scale = d3
            .scaleLinear()
            .rangeRound(config.range)
            .domain(domains)
            .nice();
          break;
      }
    } else {
      scale = d3
        .scaleLinear()
        .rangeRound(config.range)
        .domain(domains)
        .nice();
    }

    return scale;
  };

  Helper.utils.format = function(d) {
    var value = "";
    if (vm._config.formatPreffix) {
      value += vm._config.formatPreffix;
    }
    if (d === 0 || d % 1 == 0) {
      value += d3.format(",.0f")(d);
    } else if (d < 1 && d > 0) {
      value += d3.format(",.2f")(d);
    } else {
      value += d3.format(",.1f")(d);
    }
    if (vm._config.formatSuffix) {
      value += vm._config.formatSuffix;
    }
    return value;
  };

  // wrap function used in x axis labels
  Helper.utils.wrap = function(texts, width, height, lines = 2) {
    var text = d3.select(texts),
      textHeight = text.node().getBoundingClientRect().height,
      words = text
        .text()
        .split(/\s+/)
        .reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.1,
      y = text.attr("y"),
      dy = parseFloat(text.attr("dy")) || 0,
      tspan = text
        .text(null)
        .append("tspan")
        .attr("x", 0)
        .attr("y", y)
        .attr("dy", dy + "em");

    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", ++lineNumber * lineHeight + dy + "em")
          .text(word);

        // when reached the max number of lines or the possible height of the box cut text with ellipsis
        if (lineNumber >= lines - 1 || textHeight > height * 0.7) {
          var i = 1;
          while (tspan.node().getComputedTextLength() > width) {
            tspan.text(function() {
              return tspan.text().slice(0, -i) + "...";
            });
            ++i;
          }
        }
      }
    }
  };

  /**
   * @param {array} element - text selection
   * @param {number} width - max width for text selection
   * @param {number} minWidth - smallest label width
   * @param {number} largestLabelWidth - largest label width
   * @param {boolean} rotate - utils.d3.tip with html
   */
  Helper.utils.labels = function(
    element,
    width,
    minWidth,
    largestLabelWidth,
    axesTip
  ) {
    var text = d3.select(element).node();
    if (largestLabelWidth < minWidth) {
      vm.helper.utils.wrap(text, width);
    } else {
      var newLabelMaxWidth = vm._config.size.margin.bottom * 0.9;
      d3.select(text)
        .attr("text-anchor", "end")
        .attr("dy", 0)
        .attr(
          "transform",
          "translate(0," + vm._addStyle.xAxis.labels.padding + ")rotate(-90)"
        );
      if (text.getComputedTextLength() > newLabelMaxWidth) {
        if (axesTip)
          d3.select(text)
            .on("mouseover", axesTip.show)
            .on("mouseout", axesTip.hide);
        var i = 1;
        while (text.getComputedTextLength() > newLabelMaxWidth) {
          d3.select(text).text(function(d) {
            return (
              (d[vm._config.category] ? d[vm._config.category] : d + "").slice(
                0,
                -i
              ) + "..."
            );
          });
          ++i;
        }
      }
    }
  };

  Helper.utils.sortAscending = function(a, b) {
    if (!Number.isNaN(+a) && !Number.isNaN(+b)) {
      // If both values are numbers use numeric value
      return Number(a) - Number(b);
    } else if (!Number.isNaN(+a) && Number.isNaN(+b)) {
      return -1;
    } else if (Number.isNaN(+a) && !Number.isNaN(+b)) {
      return 1;
    } else if (a <= b) {
      return -1;
    } else {
      return 1;
    }
  };

  Helper.utils.sortDescending = function(a, b) {
    if (!Number.isNaN(+b) && !Number.isNaN(+a)) {
      // If both values are numbers use numeric value
      return Number(b) - Number(a);
    } else if (!Number.isNaN(+b) && Number.isNaN(+a)) {
      return -1;
    } else if (Number.isNaN(+b) && !Number.isNaN(+a)) {
      return 1;
    } else if (b <= a) {
      return -1;
    } else {
      return 1;
    }
  };

  return Helper;
}

function bars(config, helper) {
  var Bars = Object.assign({}, helper);

  Bars.init = function(config) {
    var vm = this;

    vm._config = config ? config : {};
    vm._data = [];
    vm._scales = {};
    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip bars-tip")
      .direction("n")
      .html(
        vm._config.tip ||
          function(d) {
            var html = "";
            if (vm.chart.style) {
              html +=
                "<div style='\n            line-height: 1; \n            opacity: " +
                vm.chart.style.tooltip.opacity +
                "; \n            font-weight: " +
                vm.chart.style.tooltip.text.fontWeight +
                "; \n            font-size: " +
                vm.chart.style.tooltip.text.fontSize +
                "; \n            color: " +
                vm.chart.style.tooltip.text.textColor +
                " !important;\n            font-family: " +
                vm.chart.style.tooltip.text.fontFamily +
                ";\n            background-color: " +
                vm.chart.style.tooltip.backgroundColor +
                "; \n            padding: " +
                vm.chart.style.tooltip.text.padding +
                ";   \n            border: " +
                vm.chart.style.tooltip.border.width +
                " solid " +
                vm.chart.style.tooltip.border.color +
                ";  \n            border-radius:  " +
                vm.chart.style.tooltip.border.radius +
                ";'>";
              html +=
                "<strong style='color:" +
                vm.chart.style.tooltip.text.textColor +
                " !important;'>";
            } else {
              html += "<div> <strong>";
            }
            html +=
              typeof d == "string"
                ? d
                : d[vm._config.x]
                ? 
                  (Number.isNaN(+d[vm._config.x]) ||
                  vm._config.xAxis.scale === "band"
                    ? d[vm._config.x]
                    : vm.utils.format(d[vm._config.x])) +
                  "</br>"
                : "";
            html += d[vm._config.y]
              ? 
                (Number.isNaN(+d[vm._config.y]) ||
                vm._config.yAxis.scale === "band"
                  ? d[vm._config.y]
                  : vm.utils.format(d[vm._config.y])) 
                
              : "";
            html += vm._config.tooltip.type === "percentage" ? "% </br>" : "";
            return html;
          }
      );
  };

  /**
   * User config
   */

  Bars.x = function(columnName) {
    var vm = this;
    vm._config.x = columnName;
    return vm;
  };

  Bars.y = function(columnName) {
    var vm = this;
    vm._config.y = columnName;
    return vm;
  };

  /**
   * Used to draw a bar chart with multiple bars per group
   * @param {array} columns
   */
  Bars.groupBy = function(columns) {
    var vm = this;
    vm._config.groupBy = columns;
    return vm;
  };

  /**
   * Used to draw a bar chart stacked with multiple bars per group
   * @param {array} columns
   * still needs to be checked
   */
  Bars.stackBy = function(columnName) {
    var vm = this;
    vm._config.stackBy = columnName;
    return vm;
  };

  /**
   * column name used for the domain values
   * @param {string} columnName
   */
  Bars.fill = function(columnName) {
    var vm = this;
    vm._config.fill = columnName;
    return vm;
  };

  /**
   * array of values used
   * @param {array or scale} columnName
   */
  Bars.colors = function(colors) {
    var vm = this;
    if (Array.isArray(colors)) {
      //Using an array of colors for the range
      vm._config.colors = colors;
    } else {
      //Using a preconfigured d3.scale
      vm._scales.color = colors;
    }
    return vm;
  };

  Bars.sortBy = function(option) {
    //option = string [asc,desc]
    //option = array for groupBy and stackBy
    var vm = this;
    vm._config.sortBy = option;
    return vm;
  };

  Bars.format = function(format) {
    var vm = this;
    if (typeof format == "function" || format instanceof Function) {
      vm.utils.format = format;
    } else {
      vm.utils.format = d3.format(format);
    }
    return vm;
  };

  Bars.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    return vm;
  };

  Bars.legend = function(legend) {
    var vm = this;
    vm._config.legend = legend;
    return vm;
  };

  Bars.data = function(data) {
    var vm = this;

    if (vm._config.filter) {
      //In case we want to filter observations
      data = data.filter(vm._config.filter);
    }

    if (
      vm._config.hasOwnProperty("stackBy") &&
      Array.isArray(vm._config.stackBy) &&
      vm._config.stackBy.length > 0
    ) {
      // Used in a stackbar, transpose the data into layers
      vm._data = d3.stack().keys(vm._config.stackBy)(data);
    } else {
      // Normal bar, save the data as numbers
      vm._data = data.map(function(d) {
        if (d[vm._config.x] == Number(d[vm._config.x]))
          d[vm._config.x] = +d[vm._config.x];
        if (d[vm._config.y] == Number(d[vm._config.y]))
          d[vm._config.y] = +d[vm._config.y];
        return d;
      });
    }
    //@TODO - ALLOW MULITPLE SORTS
    if (vm._config.sortBy) {
      vm._data = vm._data.sort(function(a, b) {
        return b[vm._config.sortBy[0]] - a[vm._config.sortBy[0]];
      });
    }

    if (vm._config.hasOwnProperty("quantiles")) {
      vm._quantiles = vm._setQuantile(data);
      vm._minMax = d3.extent(data, function(d) {
        return +d[vm._config.fill];
      });
    }

    return vm;
  };

  Bars.scales = function() {
    var vm = this;
    var config;
    //Normal bars
    if (vm._config.hasOwnProperty("x") && vm._config.hasOwnProperty("y")) {
      config = {
        column: vm._config.x,
        type: vm._config.xAxis.scale,
        range: [0, vm.chart.width],
        minZero: vm._config.xAxis.minZero
      };
      if (vm._config.xAxis.domains) {
        config.domains = vm._config.xAxis.domains;
      }
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      config = {
        column: vm._config.y,
        type: vm._config.yAxis.scale,
        range: [vm.chart.height, 0],
        minZero: vm._config.yAxis.minZero
      };
      if (vm._config.yAxis.domains) {
        config.domains = vm._config.yAxis.domains;
      }
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    //GroupBy bars on the xAxis
    if (
      vm._config.hasOwnProperty("x") &&
      vm._config.hasOwnProperty("groupBy")
    ) {
      /* Generate x scale */
      config = {
        column: vm._config.x,
        type: vm._config.xAxis.scale,
        groupBy: "parent",
        range: [0, vm.chart.width],
        minZero: vm._config.xAxis.minZero
      };
      if (vm._config.xAxis.domains) {
        config.domains = vm._config.xAxis.domains;
      }
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      /* Generate groupBy scale */
      config = {
        column: vm._config.groupBy,
        type: "band",
        groupBy: "children",
        range: [0, vm._scales.x.bandwidth()]
      };
      vm._scales.groupBy = vm.utils.generateScale(vm._data, config);
      //vm.chart.scales.groupBy = vm._scales.groupBy;

      /* Generate y scale */
      config = {
        column: vm._config.groupBy,
        type: vm._config.yAxis.scale,
        groupBy: "data",
        range: [vm.chart.height, 0],
        minZero: vm._config.yAxis.minZero
      };
      if (vm._config.yAxis.domains) {
        config.domains = vm._config.yAxis.domains;
      }
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    //GroupBy bars on the yAxis
    if (
      vm._config.hasOwnProperty("y") &&
      vm._config.hasOwnProperty("groupBy")
    ) {
      /* Generate y scale */
      config = {
        column: vm._config.y,
        type: vm._config.yAxis.scale,
        groupBy: "parent",
        range: [0, vm.chart.height],
        minZero: vm._config.yAxis.minZero
      };
      if (vm._config.yAxis.domains) {
        config.domains = vm._config.yAxis.domains;
      }
      vm._scales.y = vm.utils.generateScale(vm._data, config);

      /* Generate groupBy scale */
      config = {
        column: vm._config.groupBy,
        type: "band",
        groupBy: "children",
        range: [0, vm._scales.y.bandwidth()]
      };
      vm._scales.groupBy = vm.utils.generateScale(vm._data, config);
      //vm.chart.scales.groupBy = vm._scales.groupBy;

      /* Generate x scale */
      config = {
        column: vm._config.groupBy,
        type: vm._config.xAxis.scale,
        groupBy: "data",
        range: [0, vm.chart.width],
        minZero: vm._config.xAxis.minZero
      };
      if (vm._config.xAxis.domains) {
        config.domains = vm._config.xAxis.domains;
      }
      vm._scales.x = vm.utils.generateScale(vm._data, config);
    }

    //Stack bars on the xAxis
    if (
      vm._config.hasOwnProperty("x") &&
      vm._config.hasOwnProperty("stackBy")
    ) {
      /* Generate x scale */
      config = {
        column: vm._config.x,
        type: vm._config.xAxis.scale,
        stackBy: "parent",
        range: [0, vm.chart.width],
        minZero: vm._config.xAxis.minZero
      };
      if (vm._config.xAxis.domains) {
        config.domains = vm._config.xAxis.domains;
      }
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      /* Generate y scale */
      config = {
        column: "",
        stackBy: "data",
        type: vm._config.yAxis.scale,
        range: [vm.chart.height, 0],
        minZero: vm._config.yAxis.minZero
      };
      if (vm._config.yAxis.domains) {
        config.domains = vm._config.yAxis.domains;
      }
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    // Stack bars on the yAxis
    if (
      vm._config.hasOwnProperty("y") &&
      vm._config.hasOwnProperty("stackBy")
    ) {
      /* Generate x scale */
      config = {
        column: "",
        type: vm._config.xAxis.scale,
        stackBy: "data",
        range: [0, vm.chart.width],
        minZero: vm._config.xAxis.minZero
      };
      if (vm._config.xAxis.domains) {
        config.domains = vm._config.xAxis.domains;
      }
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      /* Generate y scale */
      config = {
        column: vm._config.y,
        stackBy: "parent",
        type: vm._config.yAxis.scale,
        range: [vm.chart.height, 0],
        minZero: vm._config.yAxis.minZero
      };
      if (vm._config.yAxis.domains) {
        config.domains = vm._config.yAxis.domains;
      }
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    if (vm._config.hasOwnProperty("colors"))
      vm._scales.color = d3.scaleOrdinal(vm._config.colors);
    else vm._scales.color = d3.scaleOrdinal(d3.schemeCategory10);

    return vm;
  };

  /**
   * Draw bars grouped or stacked by
   */
  Bars._drawGroupByXAxis = function() {
    var vm = this;
    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var html = d.key + "<br>";
          if (d.axis !== d.key) {
            html += d.axis + "<br>";
          }
          html += vm.utils.format(d.value);
          return html;
        }
    );

    vm.chart.svg().call(vm._tip);

    vm.chart
      .svg()
      .append("g")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .attr("transform", function(d) {
        return "translate(" + vm._scales.x(d[vm._config.x]) + ",0)";
      })
      .selectAll("rect")
      .data(function(d) {
        return vm._config.groupBy.map(function(key) {
          return {
            key: key,
            value: d[key],
            axis: d[vm._config.x]
          };
        });
      })
      .enter()
      .append("rect")
      .attr("x", function(d) {
        return vm._scales.groupBy(d.key);
      })
      .attr("y", function(d) {
        return vm._scales.y(d.value);
      })
      .attr("width", vm._scales.groupBy.bandwidth())
      .attr("height", function(d) {
        return vm.chart.height - vm._scales.y(d.value);
      })
      .attr("fill", function(d) {
        return vm._scales.color(d.key);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          // OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          // External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Bars._drawGroupByYAxis = function() {
    var vm = this;
    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var html = d.key + "<br>";
          if (d.axis !== d.key) {
            html += d.axis + "<br>";
          }
          html += vm.utils.format(d.value);
          return html;
        }
    );

    vm.chart.svg().call(vm._tip);

    vm.chart
      .svg()
      .append("g")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .attr("transform", function(d) {
        return "translate(0," + vm._scales.y(d[vm._config.y]) + " )";
      })
      .selectAll("rect")
      .data(function(d) {
        return vm._config.groupBy.map(function(key) {
          return {
            key: key,
            value: d[key],
            axis: d[vm._config.y]
          };
        });
      })
      .enter()
      .append("rect")
      .attr("y", function(d) {
        return vm._scales.groupBy(d.key);
      })
      .attr("x", 0)
      .attr("width", function(d) {
        return vm._scales.x(d.value);
      })
      .attr("height", vm._scales.groupBy.bandwidth())
      .attr("fill", function(d) {
        return vm._scales.color(d.key);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover reset default color
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          //External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Bars._drawStackByXAxis = function() {
    var vm = this;
    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var html = "";
          for (var k in d.data) {
            if ((d[1] - d[0]).toFixed(12) === Number(d.data[k]).toFixed(12)) {
              html += k + "<br>";
            }
          }
          html += d.data[vm._config.x];
          return html + "<br>" + vm.utils.format(d[1] - d[0]);
        }
    );

    vm.chart.svg().call(vm._tip);

    vm.chart
      .svg()
      .append("g")
      .attr("class", "data")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("y", function(d) {
        return vm._scales.y(d[1]);
      })
      .attr("x", function(d) {
        return vm._scales.x(d.data[vm._config.x]);
      })
      .attr("width", function(d) {
        return vm._scales.x.bandwidth();
      })
      .attr("height", function(d) {
        return vm._scales.y(d[0]) - vm._scales.y(d[1]);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover reset default color
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          //External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Bars._drawStackByYAxis = function() {
    var vm = this;

    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var html = "";
          for (var k in d.data) {
            if ((d[1] - d[0]).toFixed(12) === Number(d.data[k]).toFixed(12)) {
              html += k + "<br>";
            }
          }
          html += d.data[vm._config.y];
          return html + "<br>" + vm.utils.format(d[1] - d[0]);
        }
    );

    vm.chart.svg().call(vm._tip);

    vm.chart
      .svg()
      .append("g")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .attr("fill", function(d) {
        return vm._scales.color(d.key);
      })
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("y", function(d) {
        return vm._scales.y(d.data[vm._config.y]);
      })
      .attr("x", function(d) {
        return vm._scales.x(d[0]);
      })
      .attr("height", function(d) {
        return vm._scales.y.bandwidth();
      })
      .attr("width", function(d) {
        return vm._scales.x(d[1]) - vm._scales.x(d[0]);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover reset default color
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          //External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Bars._setQuantile = function(data) {
    var vm = this;
    var values = [];
    var quantile = [];

    if (
      vm._config.quantiles &&
      vm._config.quantiles.predefinedQuantiles &&
      vm._config.quantiles.predefinedQuantiles.length > 0
    ) {
      return vm._config.quantiles.predefinedQuantiles;
    }

    data.forEach(function(d) {
      values.push(+d[vm._config.fill]);
    });

    values.sort(d3.ascending);

    //@TODO use quantile scale instead of manual calculations
    if (vm._config && vm._config.quantiles && vm._config.quantiles.buckets) {
      if (vm._config.quantiles.ignoreZeros === true) {
        var aux = _.dropWhile(values, function(o) {
          return o <= 0;
        });
        //aux.unshift(values[0]);

        quantile.push(values[0]);
        quantile.push(0);

        for (var i = 1; i <= vm._config.quantiles.buckets - 1; i++) {
          quantile.push(
            d3.quantile(aux, (i * 1) / (vm._config.quantiles.buckets - 1))
          );
        }
      } else {
        quantile.push(d3.quantile(values, 0));
        for (var i = 1; i <= vm._config.quantiles.buckets; i++) {
          quantile.push(
            d3.quantile(values, (i * 1) / vm._config.quantiles.buckets)
          );
        }
      }
    } else {
      quantile = [
        d3.quantile(values, 0),
        d3.quantile(values, 0.2),
        d3.quantile(values, 0.4),
        d3.quantile(values, 0.6),
        d3.quantile(values, 0.8),
        d3.quantile(values, 1)
      ];
    }

    //@TODO - VALIDATE WHEN ZEROS NEED TO BE PUT ON QUANTILE 1 AND RECALCULATE NON ZERO VALUES INTO THE REST OF THE BUCKETS
    if (
      vm._config.quantiles &&
      vm._config.quantiles.buckets &&
      vm._config.quantiles.buckets === 5
    ) {
      if (
        quantile[1] === quantile[2] &&
        quantile[2] === quantile[3] &&
        quantile[3] === quantile[4] &&
        quantile[4] === quantile[5]
      ) {
        quantile = [d3.quantile(values, 0), d3.quantile(values, 0.2)];
      }
    }

    return quantile;
  };

  Bars._getQuantileColor = function(d, type) {
    var vm = this;
    var total = parseFloat(d);

    //@TODO use quantile scale instead of manual calculations
    if (
      vm._config &&
      vm._config.bars.quantiles &&
      vm._config.bars.quantiles.colors
    ) {
      if (vm._quantiles.length > 2) {
        if (
          vm._config &&
          vm._config.bars.min !== undefined &&
          vm._config.bars.max !== undefined
        ) {
          if (total < vm._config.bars.min || total > vm._config.bars.max) {
            return vm._config.bars.quantiles.outOfRangeColor;
          }
        } else {
          if (total < vm._minMax[0] || total > vm._minMax[1]) {
            return vm._config.bars.quantiles.outOfRangeColor;
          }
        }

        if (type == "default") {
          if (total <= vm._quantiles[1]) {
            return vm._config.bars.quantiles.colors[0]; //'#f7c7c5';
          } else if (total <= vm._quantiles[2]) {
            return vm._config.bars.quantiles.colors[1]; //'#e65158';
          } else if (total <= vm._quantiles[3]) {
            return vm._config.bars.quantiles.colors[2]; //'#c20216';
          } else if (total <= vm._quantiles[4]) {
            return vm._config.quantiles.colors[3]; //'#750000';
          } else if (total <= vm._quantiles[5]) {
            return vm._config.quantiles.colors[4]; //'#480000';
          }
        }

        if (
          type == "onHover" &&
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          if (total <= vm._quantiles[1]) {
            return vm._config.quantiles.colorsOnHover[0]; //'#f7c7c5';
          } else if (total <= vm._quantiles[2]) {
            return vm._config.quantiles.colorsOnHover[1]; //'#e65158';
          } else if (total <= vm._quantiles[3]) {
            return vm._config.quantiles.colorsOnHover[2]; //'#c20216';
          } else if (total <= vm._quantiles[4]) {
            return vm._config.quantiles.colorsOnHover[3]; //'#750000';
          } else if (total <= vm._quantiles[5]) {
            return vm._config.quantiles.colorsOnHover[4]; //'#480000';
          }
        }
      }
    }

    if (vm._quantiles.length == 2) {
      /*if(total === 0 ){
        return d4theme.colors.quantiles[0];//return '#fff';
      }else if(total <= vm._quantiles[1]){
        return d4theme.colors.quantiles[1];//return '#f7c7c5';
      }*/
      if (total <= vm._quantiles[1]) {
        return vm._config.quantiles.colors[0]; //'#f7c7c5';
      }
    }
  };

  Bars.draw = function() {
    var vm = this;

    if (vm._config.hasOwnProperty("groupBy")) {
      if (vm._config.hasOwnProperty("x")) vm._drawGroupByXAxis();
      if (vm._config.hasOwnProperty("y")) vm._drawGroupByYAxis();
    }

    if (vm._config.hasOwnProperty("stackBy")) {
      if (vm._config.hasOwnProperty("x")) vm._drawStackByXAxis();
      if (vm._config.hasOwnProperty("y")) vm._drawStackByYAxis();
    }
    // bars tooltip
    vm.chart.svg().call(vm._tip);

    // draw bars
    if (
      !(
        vm._config.hasOwnProperty("groupBy") ||
        vm._config.hasOwnProperty("stackBy")
      )
    ) {
      vm.chart
        .svg()
        .append("g")
        .attr("class", "data")
        .selectAll(".bar")
        .data(vm._data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", function(d) {
          return vm._config.xAxis.scale == "linear" &&
            vm._config.yAxis.scale == "linear"
            ? 0
            : vm._scales.x(d[vm._config.x]);
        })
        .attr("y", function(d) {
          return vm._scales.y(d[vm._config.y]);
        })
        .attr("width", function(d) {
          return vm._scales.x.bandwidth
            ? vm._scales.x.bandwidth()
            : vm._scales.x(d[vm._config.x]);
        })
        .attr("height", function(d) {
          return vm.chart.height - vm._scales.y(d[vm._config.y]);
        })
        .attr("fill", function(d) {
          return vm._scales.color !== false
            ? vm._scales.color(d[vm._config.fill])
            : vm._getQuantileColor(d[vm._config.fill], "default");
        })
        //.style("opacity", 0.9)
        .on("mouseover", function(d) {
          vm._tip.show(d, d3.select(this).node());
        })
        .on("mouseout", function() {
          vm._tip.hide();
        })
        .on("click", function() {});

      // needs conditional rendering just for when labels are clipped
      d3.select(".x.axis")
        .selectAll("text")
        .on("mouseover", function(d) {
          vm._tip.show(d, d3.select(this).node());
        })
        .on("mouseout", function() {
          vm._tip.hide();
        });
    }

    return vm;
  };

  Bars.init(config);

  return Bars;
}

function timeline(config, helper) {
  var Timeline = Object.assign({}, helper);

  Timeline.init = function(config) {
    var vm = this;
    vm._config = config ? config : {};
    vm._data = [];
    vm._scales = {};
    vm._axes = {};

    vm._config.parseDate = d3.timeParse("%Y-%m-%d");

    vm._line = d3
      .line()
      .curve(d3.curveLinear)
      .defined(function(d) {
        return d.y;
      })
      .x(function(d) {
        return vm._scales.x(d.x);
      })
      .y(function(d) {
        return vm._scales.y(d.y);
      });

    vm._area = d3
      .area()
      .curve(d3.curveLinear)
      .x(function(d) {
        if (d.alreadyScaled && d.alreadyScaled === true) {
          return d.x;
        } else {
          return vm._scales.x(d.x);
        }
      })
      .y1(function(d) {
        if (d.alreadyScaled && d.alreadyScaled === true) {
          return d.y;
        } else {
          return vm._scales.y(d.y);
        }
      });

    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip")
      .html(
        vm._config.tip && vm._config.tip.html
          ? vm._config.tip.html
          : function(d) {
              // set tip with styles
              var scaleColor =
                vm._scales.color !== false
                  ? vm._scales.color(d.name)
                  : vm._getQuantileColor(d.name, "default");
              if (vm.chart.config.styles) {
                var html =
                  "<div style='\n            line-height: 1; \n            opacity: " +
                  vm.chart.style.tooltip.opacity +
                  "; \n            font-weight: " +
                  vm.chart.style.tooltip.text.fontWeight +
                  "; \n            font-size: " +
                  vm.chart.style.tooltip.text.fontSize +
                  "; \n            color: " +
                  vm.chart.style.tooltip.text.textColor +
                  ";\n            font-family: " +
                  vm.chart.style.tooltip.text.fontFamily +
                  ";\n            background-color: " +
                  vm.chart.style.tooltip.backgroundColor +
                  "; \n            padding: " +
                  vm.chart.style.tooltip.text.padding +
                  ";   \n            border: " +
                  vm.chart.style.tooltip.border.width +
                  " solid " +
                  vm.chart.style.tooltip.border.color +
                  ";  \n            border-radius:  " +
                  vm.chart.style.tooltip.border.radius +
                  ";'>";
                html +=
                  "<strong style='color:" +
                  vm.chart.style.tooltip.text.textColor +
                  ";'>";
              } else {
                var html = "<div> <strong>";
              }
              html +=
                "<strong style='color:" +
                scaleColor +
                "'>" +
                d.name +
                ": </strong>";
              html += d.y
                ? "<span >" +
                  (Number.isNaN(+d.y) ? d.y : vm.utils.format(d.y)) +
                  "</span>"
                : "";
              html += "</div>";

              return html;
            }
      );
  };

  /**
   * User config functions
   */
  Timeline.x = function(col) {
    var vm = this;
    vm._config.x = col;
    return vm;
  };

  Timeline.parseDate = function(format) {
    var vm = this;
    vm._config.parseDate = d3.timeParse(format);
    return vm;
  };

  Timeline.y = function(col) {
    var vm = this;
    vm._config.y = col;
    return vm;
  };

  Timeline.series = function(arr) {
    var vm = this;
    vm._config.series = arr;
    return vm;
  };

  Timeline.fill = function(col) {
    var vm = this;
    vm._config.fill = col;
    return vm;
  };

  Timeline.colors = function(colors) {
    var vm = this;
    if (Array.isArray(colors)) {
      //Using an array of colors for the range
      vm._config.colors = colors;
    } else {
      //Using a preconfigured d3.scale
      vm._scales.color = colors;
    }
    return vm;
  };

  Timeline.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    vm._tip.html(vm._config.tip);
    return vm;
  };

  /**
   * Internal methods
   */
  Timeline.data = function(data) {
    var vm = this;

    vm._data = [];
    data.forEach(function(d) {
      d.x = vm._config.parseDate(d[vm._config.x]);
      d.color = d[vm._config.fill];
      delete d[vm._config.x];
      vm._data.push(d);
    });

    //Sort the data by d.x
    data = data.sort(function(a, b) {
      return d3.ascending(a.x, b.x);
    });

    vm._lines = vm._config.y ? vm._config.y : vm._config.series;

    vm._lines = vm._lines.map(function(name) {
      return {
        name: name,
        values: data.map(function(d) {
          return { x: d.x, y: +d[name] };
        })
      };
    });

    vm._lines.forEach(function(n) {
      n.values = n.values.filter(function(v) {
        return !isNaN(v.y);
      });
    });

    return vm;
  };

  Timeline.scales = function() {
    var vm = this;

    vm._xMinMax = d3.extent(vm._data, function(d) {
      return d.x;
    });

    vm._yMinMax = [
      vm._config.yAxis.minZero
        ? 0
        : d3.min(vm._lines, function(c) {
            return d3.min(c.values, function(v) {
              return v.y;
            });
          }),
      d3.max(vm._lines, function(c) {
        return d3.max(c.values, function(v) {
          return v.y;
        });
      })
    ];

    config = {
      column: vm._config.x,
      type: vm._config.xAxis.scale,
      range: [0, vm.chart.width],
      minZero: false
    };
    vm._scales.x = vm.utils.generateScale(vm._data, config);

    config = {
      column: vm._config.y,
      type: vm._config.yAxis.scale,
      range: [vm.chart.height, 0],
      minZero: vm._config.yAxis.minZero
    };
    vm._scales.y = vm.utils.generateScale(vm._data, config);

    vm._scales.x.domain(vm._xMinMax);
    vm._scales.y.domain(vm._yMinMax).nice();

    if (vm._config.hasOwnProperty("colors"))
      vm._scales.color = d3.scaleOrdinal(vm._config.colors);
    else vm._scales.color = d3.scaleOrdinal(d3.schemeCategory10);

    if (
      vm._scales.x.domain()[0].getTime() == vm._scales.x.domain()[1].getTime()
    ) {
      // max and min are the same, there's only one datum
      var oldDomain = vm._scales.x.domain();
      var oldRange = vm._scales.x.range();
      vm._scales.x
        .domain([0, oldDomain[0], oldDomain[1]])
        .range([0, oldRange[0] + (oldRange[1] - oldRange[0]) / 2, oldRange[1]]);
    }

    return vm;
  };

  Timeline.draw = function() {
    var vm = this;
    //Call the tip
    vm.chart.svg().call(vm._tip);

    var lines = vm.chart
      .svg()
      .selectAll(".lines")
      .data(vm._lines)
      .enter()
      .append("g")
      .attr("class", "lines");

    var path = vm.chart
      .svg()
      .selectAll(".lines")
      .append("path")
      .attr("class", "line")
      .attr("d", function(d) {
        return vm._line(d.values);
      })
      .attr("stroke", function(d) {
        return vm._scales.color !== false
          ? vm._scales.color(d.name)
          : vm._getQuantileColor(d.name, "default");
      })
      .attr("stroke-width", 4)
      .attr("fill", "none");

    /**By default it draws dots on data points with 4px radius*/
    var dots = vm.chart
      .svg()
      .selectAll(".dots")
      .data(vm._lines)
      .enter()
      .append("g")
      .attr("class", "dots")
      .selectAll(".circle")
      .data(function(d) {
        d.values.forEach(function(el) {
          el.name = d.name;
        });
        return d.values;
      })
      .enter()
      .append("circle")
      .attr("class", "dot")
      .attr("cx", function(d, i) {
        return vm._scales.x(d.x);
      })
      .attr("cy", function(d) {
        return vm._scales.y(d.y);
      })
      .attr("r", 4)
      .style("stroke", function(d) {
        return vm._scales.color !== false
          ? vm._scales.color(d.name)
          : vm._getQuantileColor(d.name, "default");
      })
      .style("stroke-width", 2)
      .style("fill", "#fff")
      .style("fill-opacity", 0.5)
      .on("mouseover", function(d, i) {
        if (vm._config.mouseover) {
          //vm._config.mouseover.call(vm, d, i);
        }
        vm._tip.show(d, d3.select(this).node());
      })
      .on("mouseout", function(d, i) {
        if (vm._config.mouseout) {
          //vm._config.mouseout.call(this, d, i);
        }
        vm._tip.hide(d, d3.select(this).node());
      });

    return vm;
  };

  Timeline.init(config);
  return Timeline;
}

function scatter(config, helper) {
  var Scatter = Object.assign({}, helper);

  Scatter.init = function(config) {
    var vm = this;
    vm._config = config ? config : {};
    vm._data = [];
    vm._scales = {};
    vm._axes = {};

    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip")
      .html(
        vm._config.tip && vm._config.tip.html
          ? vm._config.tip.html
          : function(d) {
              if (vm.chart.style) {
                var html =
                  "<div style='\n            line-height: 1; \n            opacity: " +
                  vm.chart.style.tooltip.opacity +
                  "; \n            font-weight: " +
                  vm.chart.style.tooltip.text.fontWeight +
                  "; \n            font-size: " +
                  vm.chart.style.tooltip.text.fontSize +
                  "; \n            color: " +
                  vm.chart.style.tooltip.text.textColor +
                  ";\n            font-family: " +
                  vm.chart.style.tooltip.text.fontFamily +
                  ";\n            background-color: " +
                  vm.chart.style.tooltip.backgroundColor +
                  "; \n            padding: " +
                  vm.chart.style.tooltip.text.padding +
                  ";   \n            border: " +
                  vm.chart.style.tooltip.border.width +
                  " solid " +
                  vm.chart.style.tooltip.border.color +
                  ";  \n            border-radius:  " +
                  vm.chart.style.tooltip.border.radius +
                  ";'>";
                html +=
                  "<strong style='color:" +
                  vm.chart.style.tooltip.text.textColor +
                  ";'>";
              } else {
                var html = "<div> <strong>";
              }
              html += vm._config.idName
                ? d.datum[vm._config.idName]
                  ? d.datum[vm._config.idName] + "<br>"
                  : ""
                : "";
              html += d.x
                ? "<span>(" +
                  (Number.isNaN(+d.x) || vm._config.xAxis.scale !== "linear"
                    ? d.x
                    : vm.utils.format(d.x)) +
                  "</span>"
                : "";
              html += d.y
                ? "<span>, &nbsp;" +
                  (Number.isNaN(+d.y) || vm._config.yAxis.scale !== "linear"
                    ? d.y
                    : vm.utils.format(d.y)) +
                  ")</span>"
                : "";
              html += " </strong><br>";
              if (
                vm._config.magnitude &&
                d.magnitude !== d.x &&
                d.magnitude !== d.y
              ) {
                html += d.magnitude
                  ? "<span>" +
                    (Number.isNaN(+d.magnitude)
                      ? d.magnitude
                      : vm.utils.format(d.magnitude)) +
                    "</span>"
                  : "";
              }

              html += "</div>";

              return html;
            }
      );
  };

  /**
   * User config functions
   */
  Scatter.id = function(col) {
    var vm = this;
    vm._config.id = col;
    return vm;
  };

  Scatter.idName = function(col) {
    var vm = this;
    vm._config.idName = col;
    return vm;
  };

  Scatter.x = function(col) {
    var vm = this;
    vm._config.x = col;
    return vm;
  };

  Scatter.y = function(col) {
    var vm = this;
    vm._config.y = col;
    return vm;
  };

  Scatter.radius = function(radius) {
    var vm = this;
    vm._config.radius = radius;
    return vm;
  };

  Scatter.magnitude = function(magnitude) {
    var vm = this;
    vm._config.magnitude = magnitude;
    return vm;
  };

  Scatter.radiusRange = function(radiusRange) {
    var vm = this;
    vm._config.radiusRange = radiusRange;
    return vm;
  };

  Scatter.magnitudeRange = function(magnitudeRange) {
    var vm = this;
    vm._config.magnitudeRange = magnitudeRange;
    return vm;
  };

  Scatter.properties = function(properties) {
    var vm = this;
    vm._config.properties = properties;
    return vm;
  };

  Scatter.figure = function(figureType) {
    var vm = this;
    vm._config.figureType = figureType;
    return vm;
  };

  Scatter.colors = function(colors) {
    var vm = this;
    if (Array.isArray(colors)) {
      //Using an array of colors for the range
      vm._config.colors = colors;
    } else {
      //Using a preconfigured d3.scale
      vm._scales.color = colors;
    }
    return vm;
  };

  Scatter.fill = function(col) {
    var vm = this;
    vm._config.fill = col;
    return vm;
  };

  Scatter.opacity = function(opacity) {
    var vm = this;
    vm._config.opacity = opacity;
    return vm;
  };

  Scatter.regression = function(regression) {
    var vm = this;
    vm._config.regression = regression;
    return vm;
  };

  Scatter.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    vm._tip.html(vm._config.tip);
    return vm;
  };

  /**
   * Internal methods
   */
  Scatter.data = function(data) {
    var vm = this;
    var xr, yr, xMean, yMean, b1, b0, term1, term2;
    vm._data = [];

    data.forEach(function(d) {
      var m = {
        datum: undefined,
        x: undefined,
        y: undefined,
        color: undefined,
        radius: undefined,
        magnitude: undefined
      };
      m.datum = d;
      m.x =
        vm._config.xAxis.scale == "linear" ? +d[vm._config.x] : d[vm._config.x];
      m.y =
        vm._config.yAxis.scale == "linear" ? +d[vm._config.y] : d[vm._config.y];
      m.color =
        vm._config.fill.slice(0, 1) !== "#"
          ? d[vm._config.fill]
          : vm._config.fill;
      m.radius =
        vm._config.radius !== undefined
          ? isNaN(vm._config.radius)
            ? +d[vm._config.radius]
            : vm._config.radius
          : 5;

      m.magnitude =
        vm._config.magnitude !== undefined
          ? isNaN(vm._config.magnitude)
            ? +d[vm._config.magnitude]
            : vm._config.magnitude
          : 5;

      if (
        vm._config.properties !== undefined &&
        Array.isArray(vm._config.properties) &&
        vm._config.properties.length > 0
      ) {
        vm._config.properties.forEach(function(p) {
          m[p] = d[p];
        });
      }

      vm._data.push(m);
    });

    if (
      vm._config.regression === true &&
      vm._config.yAxis.scale === "linear" &&
      vm._config.xAxis.scale === "linear"
    ) {
      xMean = d3.mean(
        data.map(function(d) {
          return +d[vm._config.x];
        })
      );
      yMean = d3.mean(
        data.map(function(d) {
          return +d[vm._config.y];
        })
      );
      xr = 0;
      yr = 0;
      term1 = 0;
      term2 = 0;

      vm._data.forEach(function(m) {
        xr = m.x - xMean;
        yr = m.y - yMean;
        term1 += xr * yr;
        term2 += xr * xr;
      });

      var b1;
      var b0;

      b1 = term1 / term2;
      b0 = yMean - b1 * xMean;

      vm._data.forEach(function(m) {
        m.yhat = b0 + m.x * b1;
      });
    }

    if (vm._config.yAxis.scale !== "linear") {
      vm._data.sort(function(a, b) {
        return vm.utils.sortAscending(a.y, b.y);
      });
    }
    if (vm._config.xAxis.scale !== "linear") {
      vm._data.sort(function(a, b) {
        return vm.utils.sortAscending(a.x, b.x);
      });
    }

    return vm;
  };

  Scatter.scales = function() {
    var vm = this;

    if (vm._config.hasOwnProperty("x") && vm._config.hasOwnProperty("y")) {
      config = {
        column: "x",
        type: vm._config.xAxis.scale,
        range: [0, vm.chart.width],
        minZero: false
      };
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      config = {
        column: "y",
        type: vm._config.yAxis.scale,
        range: [vm.chart.height, 0],
        minZero: false
      };
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    if (vm._config.hasOwnProperty("colors"))
      vm._scales.color = d3.scaleOrdinal(vm._config.colors);
    else vm._scales.color = d3.scaleOrdinal(d3.schemeCategory20c);

    var radiusMinMax;
    radiusMinMax = d3.extent(vm._data, function(d) {
      return d.radius;
    });

    var magnitudeMinMax;
    magnitudeMinMax = d3.extent(vm._data, function(d) {
      return d.magnitude;
    });

    vm._scales.radius = d3
      .scaleLinear()
      .range(
        vm._config.radiusRange != undefined ? vm._config.radiusRange : [5, 15]
      )
      .domain(radiusMinMax)
      .nice();

    vm._scales.magnitude = d3
      .scaleLinear()
      .range(
        vm._config.magnitudeRange != undefined
          ? vm._config.magnitudeRange
          : [5, 20]
      )
      .domain(magnitudeMinMax)
      .nice();

    if (
      vm._config.xAxis.scaleDomain &&
      Array.isArray(vm._config.xAxis.scaleDomain)
    ) {
      vm._scales.x.domain(vm._config.xAxis.scaleDomain);
    }
    if (
      vm._config.yAxis.scaleDomain &&
      Array.isArray(vm._config.yAxis.scaleDomain)
    ) {
      vm._scales.y.domain(vm._config.yAxis.scaleDomain);
    }
    return vm;
  };

  Scatter.draw = function() {
    var vm = this;
    //Call the tip
    vm.chart.svg().call(vm._tip);

    // Squares
    if (vm._config.figureType === "square") {
      vm.chart
        .svg()
        .selectAll("square")
        .data(vm._data)
        .enter()
        .append("rect")
        .attr("class", "square")
        .attr("class", function(d, i) {
          //Backward compability with d.properties
          var id =
            d.properties !== undefined && d.properties.id !== undefined
              ? d.properties.id
              : false;
          id = vm._config.id ? vm._config.id : false;
          return id ? "scatter-" + d.datum[id] : "scatter-" + i;
        })
        .attr("width", function(d) {
          return vm._scales.magnitude(d.magnitude);
        })
        .attr("height", function(d) {
          return vm._scales.magnitude(d.magnitude);
        })
        .attr("x", function(d) {
          if (
            vm._config.xAxis.scale == "ordinal" ||
            vm._config.xAxis.scale == "band"
          ) {
            return (
              vm._scales.x(d.x) +
              vm._scales.x.bandwidth() / 2 -
              vm._scales.magnitude(d.magnitude) / 2
            );
          } else {
            return vm._scales.x(d.x);
          }
        })
        .attr("y", function(d) {
          if (
            vm._config.yAxis.scale == "ordinal" ||
            vm._config.yAxis.scale == "band"
          ) {
            return (
              vm._scales.y(d.y) +
              vm._scales.y.bandwidth() / 2 -
              vm._scales.magnitude(d.magnitude) / 2
            );
          } else {
            return vm._scales.y(d.y);
          }
        })
        .style("fill", function(d) {
          return String(d.color).slice(0, 1) !== "#"
            ? vm._scales.color(d.color)
            : d.color;
        })
        .style(
          "opacity",
          vm._config.opacity !== undefined ? vm._config.opacity : 1
        )
        .on("mouseover", function(d, i) {
          if (vm._config.events.mouseover) {
            vm._config.events.mouseover.call(vm, d, i);
          }
          vm._tip.show(d, d3.select(this).node());
        })
        .on("mouseout", function(d, i) {
          if (vm._config.events.mouseout) {
            vm._config.events.mouseout.call(this, d, i);
          }
          vm._tip.hide(d, d3.select(this).node());
        })
        .on("click", function(d, i) {
          if (vm._config.events.onClickElement) {
            vm._config.events.onClickElement.call(this, d, i);
          }
        });
    }
    // Circles
    else {
      vm.chart
        .svg()
        .selectAll(".dot")
        .data(vm._data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("class", function(d, i) {
          //Backward compability with d.properties
          var id =
            d.properties !== undefined && d.properties.id !== undefined
              ? d.properties.id
              : false;
          id = vm._config.id ? vm._config.id : false;
          return id ? "scatter-" + d.datum[id] : "scatter-" + i;
        })
        .attr("r", function(d) {
          return vm._scales.radius(d.radius);
        })
        .attr("cx", function(d) {
          if (
            vm._config.xAxis.scale == "ordinal" ||
            vm._config.xAxis.scale == "band"
          )
            return vm._scales.x(d.x) + vm._scales.x.bandwidth() / 2;
          else return vm._scales.x(d.x);
        })
        .attr("cy", function(d) {
          if (
            vm._config.yAxis.scale == "ordinal" ||
            vm._config.yAxis.scale == "band"
          )
            return vm._scales.y(d.y) + vm._scales.y.bandwidth() / 2;
          else return vm._scales.y(d.y);
        })
        .style("fill", function(d) {
          return String(d.color).slice(0, 1) !== "#"
            ? vm._scales.color(d.color)
            : d.color;
        })
        .style(
          "opacity",
          vm._config.opacity !== undefined ? vm._config.opacity : 1
        )
        .on("mouseover", function(d, i) {
          if (vm._config.events.mouseover) {
            vm._config.events.mouseover.call(vm, d, i);
          }
          vm._tip.show(d, d3.select(this).node());
        })
        .on("mouseout", function(d, i) {
          if (vm._config.events.mouseout) {
            vm._config.events.mouseout.call(this, d, i);
          }
          vm._tip.hide(d, d3.select(this).node());
        })
        .on("click", function(d, i) {
          if (vm._config.events.onClickElement) {
            vm._config.events.onClickElement.call(this, d, i);
          }
        });

      if (vm._config.regression === true) {
        var line = d3
          .line()
          .x(function(d) {
            return vm._scales.x(d.x);
          })
          .y(function(d) {
            return vm._scales.y(d.yhat);
          });

        vm.chart
          .svg()
          .append("path")
          .datum(vm._data)
          .attr("class", "line")
          .attr("d", line)
          .style("stroke", "rgb(251, 196, 58)");
      }
    }

    return vm;
  };

  Scatter.select = function(id) {
    var vm = this;
    return vm.chart.svg().select("circle.scatter-" + id);
  };

  Scatter.selectAll = function(id) {
    var vm = this;
    return vm.chart.svg().selectAll("circle");
  };

  Scatter.init(config);
  return Scatter;
}

function treemap(config, helper) {
  var Treemap = Object.assign({}, helper);

  Treemap.init = function(config) {
    var vm = this;
    vm._config = config ? config : {};
    vm._config._padding = 3;
    vm._config._labels = false;
    vm._config.tip = function(d) {
      if (vm.chart.style) {
        var html =
          "<div style='\n            line-height: 1; \n            opacity: " +
          vm.chart.style.tooltip.opacity +
          "; \n            font-weight: " +
          vm.chart.style.tooltip.text.fontWeight +
          "; \n            font-size: " +
          vm.chart.style.tooltip.text.fontSize +
          "; \n            color: " +
          vm.chart.style.tooltip.text.textColor +
          ";\n            font-family: " +
          vm.chart.style.tooltip.text.fontFamily +
          ";\n            background-color: " +
          vm.chart.style.tooltip.backgroundColor +
          "; \n            padding: " +
          vm.chart.style.tooltip.text.padding +
          ";   \n            border: " +
          vm.chart.style.tooltip.border.width +
          " solid " +
          vm.chart.style.tooltip.border.color +
          ";  \n            border-radius:  " +
          vm.chart.style.tooltip.border.radius +
          ";'>";
        html +=
          "<strong style='color:" +
          vm.chart.style.tooltip.text.textColor +
          ";'>";
      } else {
        var html = "<div> <strong>";
      }
      if (d.parent.data.name && d.parent.data.name !== "data") {
        html += "<span>" + d.parent.data.name + "</span><br>";
      }
      html += "<span>" + d.data.name + "</span><br>";
      html += "<span>Total: " + vm.utils.format(d.value) + "</span>";

      if (d.data.percentage) {
        html += "<br><span>" + vm.utils.format(d.data.percentage) + "%</span>";
      }

      html += "</div>";
      return html;
    };
    vm._data = [];
    vm._scales = {
      color: d3.scaleOrdinal(d3.schemeCategory20c)
    };
    vm._axes = {};
    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip tip-treemap")
      .direction("n")
      .html(vm._config.tip);
  };

  /**
   * User config functions
   */
  Treemap.size = function(col) {
    var vm = this;
    vm._config._size = col;
    return vm;
  };

  Treemap.colors = function(arrayOfColors, domain) {
    var vm = this;
    vm._scales.color = d3.scaleOrdinal(arrayOfColors);
    if (domain) {
      vm._scales.color.domain(domain);
    }
    return vm;
  };

  Treemap.padding = function(padding) {
    var vm = this;
    vm._config._padding = padding;
    return vm;
  };

  Treemap.nestBy = function(keys) {
    var vm = this;
    if (Array.isArray(keys)) {
      if (keys.length == 0) throw "Error: nestBy() array is empty";
      vm._config._keys = keys;
    } else if (typeof keys === "string" || keys instanceof String) {
      vm._config._keys = [keys];
    } else {
      if (keys == undefined || keys == null)
        throw "Error: nestBy() expects column names to deaggregate data";
      vm._config._keys = [keys.toString()];
      console.log(
        "nestBy() expected name of columns. Argument will be forced to string version .toString()"
      );
    }
    vm._config._labelName = vm._config._keys[vm._config._keys.length - 1]; //label will be last key
    return vm;
  };

  Treemap.format = function(format) {
    var vm = this;
    if (typeof format == "function" || format instanceof Function)
      vm.utils.format = format;
    else vm.utils.format = d3.format(format);
    return vm;
  };

  Treemap.labels = function(bool) {
    var vm = this;
    vm._config._labels = Boolean(bool);
    return vm;
  };

  Treemap.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    vm._tip.html(vm._config.tip);
    return vm;
  };

  /**
   * Internal methods
   */

  // First three functions are defaults as required by main chartmodule
  Treemap.scales = function() {
    var vm = this;
    return vm;
  };

  Treemap.axes = function() {
    var vm = this;
    return vm;
  };

  Treemap.domains = function() {
    var vm = this;
    return vm;
  };

  Treemap.isValidStructure = function(datum) {
    var vm = this;
    if (
      (typeof datum.name === "string" || datum.name instanceof String) &&
      Array.isArray(datum.children)
    ) {
      var res = true;
      datum.children.forEach(function(child) {
        res = res && vm.isValidStructure(child);
      });
      return res;
    } else if (
      (typeof datum.name === "string" || datum.name instanceof String) &&
      Number(datum[vm._config._size]) == datum[vm._config._size]
    ) {
      return true;
    } else {
      return false;
    }
  };

  Treemap.formatNestedData = function(data) {
    var vm = this;
    if (data.key) {
      data.name = data.key;
      delete data.key;
    } else {
      if (!Array.isArray(data.values)) {
        data.name = data[vm._config._labelName];
      }
    }
    if (Array.isArray(data.values)) {
      var children = [];
      var total = 0;
      data.values.forEach(v => {
        total += v.value;
      });
      data.values.forEach(v => {
        v.percentage = (v.value / total) * 100;
        children.push(vm.formatNestedData(v));
      });
      data.children = children;
      delete data.values;
    }
    if (!data[vm._config._size] && data.value) {
      data[vm._config._size] = data.value;
    }
    return data;
  };

  Treemap.nestKey = function(nest, key, callback) {
    callback(
      null,
      nest.key(function(d) {
        return d[key];
      })
    );
  };

  Treemap.data = function(data) {
    var vm = this;
    // Validate structure like [{name: '', children: [{},{}]}]
    if (data) {
      if (Array.isArray(data) && data.length > 0) {
        if (!vm.isValidStructure(data[0])) {
          if (!vm._config._size) {
            vm._config._size = "size";
          }
          data.forEach(function(d) {
            if (vm._config._size === "size") {
              d[vm._config._size] = 1;
            } else d[vm._config._size] = +d[vm._config._size];
          });
          try {
            if (!vm._config._keys) throw "nestBy() in layer was not configured";
            var nested = d3.nest();
            var queue = d3.queue();
            for (var i = 0; i < vm._config._keys.length; i++) {
              queue.defer(vm.nestKey, nested, vm._config._keys[i]);
            }
            queue.awaitAll(function(error, nested) {
              var nestedData = nested[0]
                .rollup(function(leaves) {
                  return d3.sum(leaves, function(d) {
                    return d[vm._config._size];
                  });
                })
                .entries(data);
              var aux = {
                key: undefined,
                values: undefined
              };
              aux.key = "data";
              aux.values = _.cloneDeep(nestedData);
              data = vm.formatNestedData(aux);
              vm._data = data;
            });
          } catch (err) {
            console.error(err);
          }
        }
      } else {
        if (!vm.isValidStructure(data)) {
          try {
            if (!data.key) throw "Property 'key' not found";
            if (data[vm._config._size] !== Number(data[vm._config._size]))
              throw "Value used for treemap rect size is not a number";
            data = vm.formatNestedData(data);
            vm._data = data;
          } catch (err) {
            console.error(err);
          }
        }
      }
    }
    return vm;
  };

  Treemap.draw = function() {
    var vm = this;
    vm.chart.svg().call(vm._tip);

    var treemap = d3
      .treemap()
      .tile(d3.treemapResquarify)
      .size([vm.chart.width, vm.chart.height])
      .round(true)
      .paddingInner(vm._config._padding);

    var root = d3
      .hierarchy(vm._data)
      .eachBefore(function(d) {
        d.data.id = (d.parent ? d.parent.data.id + "." : "") + d.data.name;
      })
      .sum(function(d) {
        return d[vm._config._size];
      })
      .sort(function(a, b) {
        return b.height - a.height || b.value - a.value;
      });

    treemap(root);

    console.log(root.leaves());

    var cell = vm.chart
      .svg()
      .selectAll("g")
      .data(root.leaves())
      .enter()
      .append("g")
      .attr("transform", function(d) {
        return "translate(" + d.x0 + "," + d.y0 + ")";
      });

    var rect = cell
      .append("rect")
      .attr("id", function(d) {
        return d.data.id;
      })
      .attr("width", function(d) {
        return d.x1 - d.x0;
      })
      .attr("height", function(d) {
        return d.y1 - d.y0;
      })
      .attr("fill", function(d) {
        //console.log('fill', d);
        //console.log(vm._scales.color.range());
        //console.log(vm._scales.color.domain());
        return vm._scales.color(d.data.name);
      });

    cell
      .append("clipPath")
      .attr("id", function(d) {
        return "clip-" + d.data.id;
      })
      .append("use")
      .attr("xlink:href", function(d) {
        return "#" + d.data.id;
      });

    if (vm._config._labels) {
      var text = cell.append("text").attr("clip-path", function(d) {
        return "url(#clip-" + d.data.id + ")";
      });
      if (vm.chart.style.labels) {
        text
          .style("font-size", vm.chart.style.labels.fontSize)
          .style("font-weight", vm.chart.style.labels.fontWeight)
          .style(
            "transform",
            "rotate(" + vm.chart.style.labels.rotation + "deg)"
          )
          .attr("text-anchor", vm.chart.style.labels.textAnchor);
      }
      text
        .append("tspan")
        .attr("class", "capitalize")
        .attr("x", 8)
        .attr("y", 25)
        .attr("fill", vm.chart.style.labels.textColor)
        .text(function(d) {
          if (d.value > 2 || d.data.percentage > 10) {
            var arr = d.data.id.replace("data.", "").split(".");
            return arr.length > 1
              ? arr.slice(arr.length - 2, arr.length).join(" / ")
              : arr[arr.length - 1].toString();
          } else return "";
        });
      text
        .append("tspan")
        .attr("class", "capitalize")
        .attr("x", 8)
        .attr("y", 45)
        .attr("fill", vm.chart.style.labels.textColor)
        .text(function(d) {
          //return d.data.value > 2 ? vm.utils.format(d.data.value) : '';
          return d.data.percentage > 10
            ? vm.utils.format(d.data.percentage) + "%"
            : "";
        });
    }

    rect
      .on("mouseover", function(d) {
        /* in case of custom event handler
      if(vm._config.data.mouseover){
        vm._config.data.mouseover.call(vm, d,i);
      }*/
        vm._tip.show(d, d3.select(this).node());
      })
      .on("mouseout", function(d) {
        /* in case of custom event handler
      if(vm._config.data.mouseout){
        vm._config.data.mouseout.call(this, d,i);
      }*/
        vm._tip.hide(d, d3.select(this).node());
      });

    return vm;
  };

  Treemap.init(config);

  return Treemap;
}

function spineplot(config, helper) {
  var Spineplot = Object.assign({}, helper);

  Spineplot.init = function(config) {
    var vm = this;
    vm._config = config ? config : {};
    vm._config.orientation = "horizontal";
    vm._data = [];
    vm._scales = {};
    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip")
      .direction("n")
      .html(
        vm._config.tip ||
          function(d) {
            var html = "<div>";
            html += "<span>" + d[vm._config.category] + "</span>";
            html +=
              "</br><span>" + vm.utils.format(d[vm._config.value]) + "</span>";
            html += "</div>";
            return html;
          }
      );
  };

  /**
   * User config functions
   */

  Spineplot.id = function(columnName) {
    var vm = this;
    vm._config.id = columnName;
    return vm;
  };

  Spineplot.category = function(columnName) {
    var vm = this;
    vm._config.category = columnName;
    return vm;
  };

  Spineplot.value = function(columnName) {
    var vm = this;
    vm._config.value = columnName;
    return vm;
  };

  Spineplot.orientation = function(orientation) {
    var vm = this;
    vm._config.orientation = orientation;
    return vm;
  };

  /**
   * Used to draw a bar chart stacked with multiple bars per group
   * @param {array} columns
   */
  Spineplot.stackBy = function(columnName) {
    var vm = this;
    vm._config.stackBy = columnName;
    return vm;
  };

  /**
   * column name used for the domain values
   * @param {string} columnName
   */
  Spineplot.fill = function(columnName) {
    var vm = this;
    vm._config.fill = columnName;
    return vm;
  };

  /**
   * array of values used
   * @param {array or scale} columnName
   */
  Spineplot.colors = function(colors) {
    var vm = this;
    if (Array.isArray(colors)) {
      //Using an array of colors for the range
      vm._config.colors = colors;
    } else {
      //Using a preconfigured d3.scale
      vm._scales.color = colors;
    }
    return vm;
  };

  Spineplot.sortBy = function(option) {
    //option = string [asc,desc]
    //option = array for groupBy and stackBy
    var vm = this;
    vm._config.sortBy = option;
    return vm;
  };

  Spineplot.format = function(format) {
    var vm = this;
    if (typeof format == "function" || format instanceof Function)
      vm.utils.format = format;
    else vm.utils.format = d3.format(format);
    return vm;
  };

  Spineplot.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    return vm;
  };

  Spineplot.legend = function(legend) {
    var vm = this;
    vm._config.legend = legend;
    return vm;
  };

  /**
   * Internal methods
   */
  Spineplot.data = function(data) {
    var vm = this;

    if (vm._config.filter) {
      data = data.filter(vm._config.filter);
    }
    // Sort by one var
    if (vm._config.sortBy) {
      if (vm._config.sortBy.category) {
        data = data.sort(function(a, b) {
          return vm._config.sortBy.category === "desc"
            ? vm.utils.sortDescending(
                a[vm._config.category],
                b[vm._config.category]
              )
            : vm.utils.sortAscending(
                a[vm._config.category],
                b[vm._config.category]
              );
        });
      }
      if (vm._config.sortBy.value) {
        data = data.sort(function(a, b) {
          return vm._config.sortBy.value === "desc"
            ? vm.utils.sortDescending(a[vm._config.value], b[vm._config.value])
            : vm.utils.sortAscending(a[vm._config.value], b[vm._config.value]);
        });
      }
    } else {
      data = data.sort(function(a, b) {
        return vm.utils.sortAscending(
          a[vm._config.category],
          b[vm._config.category]
        );
      });
    }

    var total = 0;
    vm._data = data.map(function(d) {
      d.x0 = total;
      d.x1 = total + d[vm._config.value];
      total += +d[vm._config.value];
      if (
        vm._config.hasOwnProperty("stackBy") &&
        Array.isArray(vm._config.stackBy) &&
        vm._config.stackBy.length > 0
      ) {
        d.stackValues = d3.stack().keys(vm._config.stackBy)([d]);
        d.totalCollapse = d3.sum(d.stackValues, function(stack) {
          return stack[0][1] - stack[0][0];
        });
      }
      return d;
    });

    if (vm._config.hasOwnProperty("quantiles")) {
      vm._quantiles = vm._setQuantile(data);
      vm._minMax = d3.extent(data, function(d) {
        return +d[vm._config.fill];
      });
    }

    return vm;
  };

  Spineplot.scales = function() {
    var vm = this;
    var config;

    // Normal bars
    if (
      vm._config.hasOwnProperty("category") &&
      vm._config.hasOwnProperty("value")
    ) {
      config = {
        column: "x1",
        type: "linear",
        range: [0, vm.chart.width],
        minZero: true
      };
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      config = {
        column: vm._config.value,
        type: "linear",
        range: [vm.chart.height, 0],
        minZero: true
      };
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    //Stack bars on the xAxis
    if (
      vm._config.orientation === "horizontal" &&
      vm._config.hasOwnProperty("stackBy")
    ) {
      /* Generate x scale */
      config = {
        column: "x1",
        type: "linear",
        range: [0, vm.chart.width],
        minZero: true
      };
      vm._scales.x = vm.utils.generateScale(vm._data, config);

      /* Generate y scale */
      config = {
        column: "",
        type: "linear",
        range: [vm.chart.height, 0],
        minZero: true
      };
      vm._scales.y = d3
        .scaleLinear()
        .range(config.range)
        .domain([0, 1]);
    }

    //Stack bars on the yAxis
    if (
      vm._config.orientation === "vertical" &&
      vm._config.hasOwnProperty("stackBy")
    ) {
      /* Generate x scale */
      config = {
        column: "",
        txpe: "linear",
        range: [vm.chart.height, 0],
        minZero: true
      };
      vm._scales.x = d3
        .scaleLinear()
        .range(config.range)
        .domain([0, 1]);

      /* Generate y scale */
      config = {
        column: vm._config.value,
        type: "linear",
        range: [0, vm.chart.width],
        minZero: true
      };
      vm._scales.y = vm.utils.generateScale(vm._data, config);
    }

    if (vm._config.hasOwnProperty("colors"))
      vm._scales.color = d3.scaleOrdinal(vm._config.colors);
    else vm._scales.color = d3.scaleOrdinal(d3.schemeCategory10);

    return vm;
  };

  /**
   * Draw stacked by
   */
  Spineplot._drawStackByXAxis = function() {
    var vm = this;
    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var cat = "";
          cat += "<span>" + d.key + "</span>";
          if (d.key !== d[0].data[vm._config.category]) {
            cat += "<br><span>" + d[0].data[vm._config.category] + "</span>";
          }
          cat += "<br><span>" + vm.utils.format(d[0].data[d.key]) + "</span>";
          return cat;
        }
    );

    vm.chart.svg().call(vm._tip);

    var axesTip = vm.utils.d3
      .tip()
      .attr("class", "title-tip")
      .html(function(d) {
        return d[vm._config.category];
      });

    vm.chart.svg().call(axesTip);

    /**
     * x axis labels
     */
    vm._xLabels = vm.chart
      .svg()
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + vm.chart.height + ")")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .attr("class", "tick")
      .attr("transform", function(d) {
        var x = vm._scales.x(d.x0) + vm._scales.x(d.x1 - d.x0) / 2 + 2;
        return (
          "translate(" +
          x +
          ", " +
          vm.chart.style.xAxis.labels.padding +
          ")rotate(" +
          vm.chart.style.xAxis.labels.rotation +
          ")"
        );
      })
      .append("text")
      .attr("text-anchor", "start")
      .text(function(d) {
        return d[vm._config.category];
      });

    var labelMinWidth = d3.min(vm._data, function(d) {
      return (vm._scales.x(d.x1) - vm._scales.x(d.x0)) * 0.9;
    });
    var largestLabelWidth = d3.max(vm._xLabels.nodes(), function(node) {
      return node.getComputedTextLength();
    });

    vm._xLabels.each(function(d) {
      vm.utils.labels(
        this,
        vm._scales.x(d.x1) - vm._scales.x(d.x0),
        labelMinWidth,
        largestLabelWidth,
        axesTip
      );
    });

    var groups = vm.chart
      .svg()
      .append("g")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g");

    groups
      .selectAll("rect")
      .data(function(d) {
        return d.stackValues;
      })
      .enter()
      .append("rect")
      .attr("y", function(d) {
        return d[0][1]
          ? vm._scales.y(d[0][1] / d[0].data.totalCollapse)
          : vm._scales.y(0);
      })
      .attr("x", function(d) {
        return vm._scales.x(d[0].data.x0);
      })
      .attr("width", function(d) {
        return vm._scales.x(d[0].data[vm._config.value]);
      })
      .attr("height", function(d) {
        return (
          vm._scales.y(d[0][0] / d[0].data.totalCollapse) -
          vm._scales.y(d[0][1] / d[0].data.totalCollapse)
        );
      })
      .attr("stroke", "white")
      .attr("stroke-width", 1)
      .attr("fill", function(d) {
        return vm._scales.color(d[vm._config.fill]);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover reset default color
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          //External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Spineplot._drawStackByYAxis = function() {
    var vm = this;

    vm._tip.html(
      vm._config.tip ||
        function(d) {
          var html = "<div><span>" + d[vm._config.category] + "<span><br>";
          for (var k in d.data) {
            if (d[1] - d[0] == d.data[k]) {
              html += "<span>" + k + "</span>";
            }
          }
          html += "<br>" + vm.utils.format(d[1] - d[0]);
          return html;
        }
    );

    vm.chart.svg().call(vm._tip);

    vm.chart
      .svg()
      .append("g")
      .selectAll("g")
      .data(vm._data)
      .enter()
      .append("g")
      .attr("fill", function(d) {
        return vm._scales.color(d.key);
      })
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("y", function(d) {
        return vm._scales.y(d.data[vm._config.value]);
      })
      .attr("x", function(d) {
        return vm._scales.x(d[0]);
      })
      .attr("height", vm._scales.y.bandwidth())
      .attr("width", function(d) {
        return vm._scales.x(d[1]) - vm._scales.x(d[0]);
      })
      .on("mouseover", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover colors
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "onHover");
          });
        }
        vm._tip.show(d, d3.select(this).node());

        if (vm._config.hasOwnProperty("onmouseover")) {
          //External function call. It must be after all the internal code; allowing the user to overide
          vm._config.onmouseover.call(this, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        if (
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          //OnHover reset default color
          d3.select(this).attr("fill", function(d) {
            return vm._getQuantileColor(d[vm._config.fill], "default");
          });
        }
        vm._tip.hide();

        if (vm._config.hasOwnProperty("onmouseout")) {
          //External function call, must be after all the internal code; allowing the user to overide
          vm._config.onmouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("click")) {
          vm._config.onclick.call(this, d, i);
        }
      });
  };

  Spineplot._setQuantile = function(data) {
    var vm = this;
    var values = [];
    var quantile = [];

    if (
      vm._config.quantiles &&
      vm._config.quantiles.predefinedQuantiles &&
      vm._config.quantiles.predefinedQuantiles.length > 0
    ) {
      return vm._config.quantiles.predefinedQuantiles;
    }

    data.forEach(function(d) {
      values.push(+d[vm._config.fill]);
    });

    values.sort(vm.utils.sortAscending);

    //@TODO use quantile scale instead of manual calculations
    if (vm._config && vm._config.quantiles && vm._config.quantiles.buckets) {
      if (vm._config.quantiles.ignoreZeros === true) {
        var aux = _.dropWhile(values, function(o) {
          return o <= 0;
        });
        //aux.unshift(values[0]);

        quantile.push(values[0]);
        quantile.push(0);

        for (var i = 1; i <= vm._config.quantiles.buckets - 1; i++) {
          quantile.push(
            d3.quantile(aux, (i * 1) / (vm._config.quantiles.buckets - 1))
          );
        }
      } else {
        quantile.push(d3.quantile(values, 0));
        for (var j = 1; j <= vm._config.quantiles.buckets; j++) {
          quantile.push(
            d3.quantile(values, (j * 1) / vm._config.quantiles.buckets)
          );
        }
      }
    } else {
      quantile = [
        d3.quantile(values, 0),
        d3.quantile(values, 0.2),
        d3.quantile(values, 0.4),
        d3.quantile(values, 0.6),
        d3.quantile(values, 0.8),
        d3.quantile(values, 1)
      ];
    }

    //@TODO - VALIDATE WHEN ZEROS NEED TO BE PUT ON QUANTILE 1 AND RECALCULATE NON ZERO VALUES INTO THE REST OF THE BUCKETS
    if (
      vm._config.quantiles &&
      vm._config.quantiles.buckets &&
      vm._config.quantiles.buckets === 5
    ) {
      if (
        quantile[1] === quantile[2] &&
        quantile[2] === quantile[3] &&
        quantile[3] === quantile[4] &&
        quantile[4] === quantile[5]
      ) {
        quantile = [d3.quantile(values, 0), d3.quantile(values, 0.2)];
      }
    }

    return quantile;
  };

  Spineplot._getQuantileColor = function(d, type) {
    var vm = this;
    var total = parseFloat(d);

    //@TODO use quantile scale instead of manual calculations
    if (
      vm._config &&
      vm._config.bars.quantiles &&
      vm._config.bars.quantiles.colors
    ) {
      if (vm._quantiles.length > 2) {
        if (
          vm._config &&
          vm._config.bars.min !== undefined &&
          vm._config.bars.max !== undefined
        ) {
          if (total < vm._config.bars.min || total > vm._config.bars.max) {
            return vm._config.bars.quantiles.outOfRangeColor;
          }
        } else {
          if (total < vm._minMax[0] || total > vm._minMax[1]) {
            return vm._config.bars.quantiles.outOfRangeColor;
          }
        }

        if (type == "default") {
          if (total <= vm._quantiles[1]) {
            return vm._config.bars.quantiles.colors[0]; //'#f7c7c5';
          } else if (total <= vm._quantiles[2]) {
            return vm._config.bars.quantiles.colors[1]; //'#e65158';
          } else if (total <= vm._quantiles[3]) {
            return vm._config.bars.quantiles.colors[2]; //'#c20216';
          } else if (total <= vm._quantiles[4]) {
            return vm._config.quantiles.colors[3]; //'#750000';
          } else if (total <= vm._quantiles[5]) {
            return vm._config.quantiles.colors[4]; //'#480000';
          }
        }

        if (
          type == "onHover" &&
          vm._config.hasOwnProperty("quantiles") &&
          vm._config.quantiles.hasOwnProperty("colorsOnHover")
        ) {
          if (total <= vm._quantiles[1]) {
            return vm._config.quantiles.colorsOnHover[0]; //'#f7c7c5';
          } else if (total <= vm._quantiles[2]) {
            return vm._config.quantiles.colorsOnHover[1]; //'#e65158';
          } else if (total <= vm._quantiles[3]) {
            return vm._config.quantiles.colorsOnHover[2]; //'#c20216';
          } else if (total <= vm._quantiles[4]) {
            return vm._config.quantiles.colorsOnHover[3]; //'#750000';
          } else if (total <= vm._quantiles[5]) {
            return vm._config.quantiles.colorsOnHover[4]; //'#480000';
          }
        }
      }
    }

    if (vm._quantiles.length == 2) {
      /*if(total === 0 ){
        return d4theme.colors.quantiles[0];//return '#fff';
      }else if(total <= vm._quantiles[1]){
        return d4theme.colors.quantiles[1];//return '#f7c7c5';
      }*/
      if (total <= vm._quantiles[1]) {
        return vm._config.quantiles.colors[0]; //'#f7c7c5';
      }
    }
  };

  Spineplot.draw = function() {
    var vm = this;
    if (vm._config.hasOwnProperty("stackBy")) {
      if (vm._config.orientation === "horizontal")
        return vm._drawStackByXAxis();
      if (vm._config.orientation === "vertical") return vm._drawStackByYAxis();
      return vm;
    }

    vm.chart.svg().call(vm._tip);

    var axesTip = vm.utils.d3
      .tip()
      .attr("class", "title-tip")
      .html(function(d) {
        return d[vm._config.category];
      });
    vm.chart.svg().call(axesTip);

    if (vm._config.orientation === "horizontal") {
      /**
       * x axis tick labels
       */
      vm._xLabels = vm.chart
        .svg()
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + (vm.chart.height + 20) + ")")
        .selectAll(".tick")
        .data(vm._data)
        .enter()
        .append("g")
        .attr("class", "tick")
        .attr("transform", function(d) {
          var x = vm._scales.x(d.x0) + vm._scales.x(d.x1 - d.x0) / 2;
          return "translate(" + x + ", 8)";
        })
        .append("text")
        .attr("text-anchor", "middle")
        .text(function(d) {
          return d[vm._config.category];
        });

      var labelMinWidth = d3.min(vm._data, function(d) {
        return (vm._scales.x(d.x1) - vm._scales.x(d.x0)) * 0.9;
      });
      var largestLabelWidth = d3.max(vm._xLabels.nodes(), function(node) {
        return node.getComputedTextLength();
      });

      vm._xLabels.each(function(d) {
        vm.utils.labels(this, labelMinWidth, largestLabelWidth, axesTip);
      });

      // bars
      vm.chart
        .svg()
        .selectAll(".bar")
        .data(vm._data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("id", function(d, i) {
          var id = "spineplot-" + i;
          if (vm._config.id) {
            id = "spineplot-" + d[vm._config.id];
          }
          return id;
        })
        .attr("x", function(d) {
          return vm._scales.x(d.x0);
        })
        .attr("y", 0)
        .attr("width", function(d) {
          return vm._scales.x(d[vm._config.value]);
        })
        .attr("height", vm.chart.height)
        .attr("fill", function(d) {
          return vm._scales.color !== false
            ? vm._scales.color(d[vm._config.fill])
            : vm._getQuantileColor(d[vm._config.fill], "default");
        })
        .attr("stroke", "white")
        .attr("stroke-width", 1)
        .style("opacity", 0.9)
        .on("mouseover", function(d, i) {
          if (
            vm._config.hasOwnProperty("quantiles") &&
            vm._config.quantiles.hasOwnProperty("colorsOnHover")
          ) {
            //OnHover colors
            d3.select(this).attr("fill", function(d) {
              return vm._getQuantileColor(d[vm._config.fill], "onHover");
            });
          }
          vm._tip.show(d, d3.select(this).node());

          if (vm._config.hasOwnProperty("onmouseover")) {
            //External function call, must be after all the internal code; allowing the user to overide
            vm._config.onmouseover.call(this, d, i);
          }
        })
        .on("mouseout", function(d, i) {
          if (
            vm._config.hasOwnProperty("quantiles") &&
            vm._config.quantiles.hasOwnProperty("colorsOnHover")
          ) {
            //OnHover reset default color
            d3.select(this).attr("fill", function(d) {
              return vm._getQuantileColor(d[vm._config.fill], "default");
            });
          }
          vm._tip.hide();

          if (vm._config.hasOwnProperty("onmouseout")) {
            //External function call, must be after all the internal code; allowing the user to overide
            vm._config.onmouseout.call(this, d, i);
          }
        })
        .on("click", function(d, i) {
          if (vm._config.hasOwnProperty("click")) {
            vm._config.onclick.call(this, d, i);
          }
        });
    }
    return vm;
  };

  Spineplot.init(config);

  return Spineplot;
}

function heatmap(config, helper) {
  var Heatmap = Object.assign({}, helper);

  Heatmap.init = function(config) {
    var vm = this;
    vm._config = config ? config : {};
    vm._data = [];
    vm._scales = {};
    vm._axes = {};

    vm._legendElementWidth = vm._gridWidth;

    vm._tip = vm.utils.d3
      .tip()
      .attr("class", "d3-tip")
      .direction("n")
      .html(
        vm._config.tip ||
          function(d) {
            var html = d.x;
            if (d.x !== d.y) {
              html += "<br>" + d.y;
            }
            html += "<br>" + vm.utils.format(d.value);
            return html;
          }
      );
  };

  /**
   * User config functions
   */
  Heatmap.x = function(column) {
    var vm = this;
    vm._config.x = column;
    return vm;
  };

  Heatmap.y = function(column) {
    var vm = this;
    vm._config.y = column;
    return vm;
  };

  Heatmap.fill = function(column) {
    var vm = this;
    vm._config.fill = column;
    return vm;
  };

  Heatmap.colors = function(colors) {
    var vm = this;
    vm._config.colors = colors;
    return vm;
  };

  Heatmap.colorLegend = function(legendTitle) {
    var vm = this;
    vm._config.legendTitle = legendTitle;
    return vm;
  };

  Heatmap.borderRadius = function(radius) {
    var vm = this;
    vm._config.borderRadius = radius;
    return vm;
  };

  Heatmap.sortBy = function(sortBy) {
    var vm = this;
    vm._config.sortBy = sortBy;
    return vm;
  };

  Heatmap.tip = function(tip) {
    var vm = this;
    vm._config.tip = tip;
    vm._tip.html(vm._config.tip);
    return vm;
  };

  /**
   * Internal methods
   */

  Heatmap.data = function(data) {
    var vm = this;
    var xSort = vm.utils.sortAscending;
    var ySort = vm.utils.sortAscending;

    if (typeof vm._config.sortBy === "string") {
      if (vm._config.hasOwnProperty("sortBy") && vm._config.sortBy === "desc")
        xSort = vm.utils.sortDescending;
    }

    if (typeof vm._config.sortBy === "object") {
      if (
        vm._config.hasOwnProperty("sortBy") &&
        vm._config.sortBy.hasOwnProperty("x") &&
        vm._config.sortBy.x === "desc"
      )
        xSort = vm.utils.sortDescending;
      if (
        vm._config.hasOwnProperty("sortBy") &&
        vm._config.sortBy.hasOwnProperty("y") &&
        vm._config.sortBy.y === "desc"
      )
        ySort = vm.utils.sortDescending;
    }

    vm._config.xCategories = d3
      .nest()
      .key(function(d) {
        return d[vm._config.x];
      })
      .sortKeys(xSort)
      .entries(data)
      .map(function(d) {
        return d.key;
      });

    vm._config.yCategories = d3
      .nest()
      .key(function(d) {
        return d[vm._config.y];
      })
      .sortKeys(ySort)
      .entries(data)
      .map(function(d) {
        return d.key;
      });

    vm._config.fillValues = d3
      .nest()
      .key(function(d) {
        return d[vm._config.fill];
      })
      .entries(data)
      .map(function(d) {
        return Number(d.key);
      });

    /**
     * Calculate grid width and height according to chart size
     */
    vm._gridWidth = Math.floor(
      (vm._config.size.width -
        (vm._config.size.margin.left + vm._config.size.margin.right)) /
        vm._config.xCategories.length
    );

    vm._gridHeight = Math.floor(
      (vm._config.size.height -
        (vm._config.size.margin.top + vm._config.size.margin.bottom)) /
        vm._config.yCategories.length
    );

    vm._data = data.map(function(d) {
      var m = {
        y: d[vm._config.y],
        x: d[vm._config.x],
        value: +d[vm._config.fill]
      };
      return m;
    });

    return vm;
  };

  Heatmap.scales = function() {
    var vm = this;
    return vm;
  };

  Heatmap.drawColorLegend = function() {
    var vm = this;

    var domain = vm._config.colors;
    var quantilePosition = d3
      .scaleBand()
      .rangeRound([vm._config.size.height * 0.8, 0])
      .domain(domain);
    //Add gradient legend
    //defaults to right position
    var legend = d3
      .select(vm._config.bindTo)
      .select("svg")
      .append("g")
      .attr("class", "legend quantized")
      .attr(
        "transform",
        "translate(" +
          (vm._config.size.width - 100) +
          "," +
          vm._config.size.height * 0.1 +
          ")"
      );

    // legend background
    legend
      .append("rect")
      .attr("x", -50)
      .attr("y", -35)
      .attr("width", 100)
      .attr("height", vm._config.size.height - 10)
      .attr("rx", 10)
      .attr("ry", 10)
      .attr("class", "legend-background")
      .attr("fill", "rgba(255,255,255,0.6)");

    // legend title
    legend
      .append("text")
      .attr("x", 19)
      .attr("y", -12)
      .attr("class", "legend-title")
      .attr("text-anchor", "end")
      .text(vm._config.legendTitle);

    var quantiles = legend
      .selectAll(".quantile")
      .data(vm._config.colors)
      .enter()
      .append("g")
      .attr("class", "quantile")
      .attr("transform", function(d) {
        return "translate(-20, " + quantilePosition(d) + ")";
      });

    // Rect
    quantiles
      .append("rect")
      .attr("x", -15)
      .attr("y", 0)
      .attr("width", 18)
      .attr("height", quantilePosition.bandwidth())
      .attr("fill", function(d) {
        return d;
      });

    // top text is the max value
    quantiles
      .append("text")
      .attr("x", 17)
      .attr("y", 5)
      .attr("class", "top-label")
      .attr("text-anchor", "left")
      .text(function(d) {
        var max = vm._scales.color.invertExtent(d)[1];
        if (vm._config.legendTitle === "Porcentaje" && max > 100) {
          max = 100;
        }
        return vm.utils.format(max);
      });

    // bottom text is the min value
    quantiles
      .append("text")
      .attr("x", 17)
      .attr("y", vm._config.size.height / 5 - 18)
      .attr("class", "bottom-label")
      .attr("text-anchor", "left")
      .text(function(d, i) {
        if (i === 0) {
          var min = vm._scales.color.invertExtent(d)[0];
          return vm.utils.format(min);
        } else {
          return "";
        }
      });
  };

  Heatmap.draw = function() {
    var vm = this;

    //Call the tip
    vm.chart.svg().call(vm._tip);

    var axesTip = vm.utils.d3.tip().html(function(d) {
      return '<div class="title-tip">' + d + "</div>";
    });
    vm.chart.svg().call(axesTip);

    vm._yLabels = vm.chart
      .svg()
      .append("g")
      .attr("class", "y axis")
      .attr("transform", "translate(0,0)")
      .selectAll(".tick")
      .data(vm._config.yCategories)
      .enter()
      .append("g")
      .attr("class", "tick")
      .attr("transform", function(d, i) {
        return "translate(0," + i * vm._gridHeight + ")";
      })
      .append("text")
      .attr("text-anchor", "end")
      .attr("transform", "translate(-6," + vm._gridHeight / 1.5 + ")")
      .text(function(d) {
        return d;
      });

    vm._yLabels.each(function(d) {
      var _this = this;

      if (this.getComputedTextLength() > vm._config.size.margin.left * 0.9) {
        (function() {
          d3.select(_this)
            .on("mouseover", axesTip.show)
            .on("mouseout", axesTip.hide);
          var i = 1;
          while (
            _this.getComputedTextLength() >
            vm._config.size.margin.left * 0.9
          ) {
            d3.select(_this)
              .text(function(d) {
                return d.slice(0, -i) + "...";
              })
              .attr("title", d);
            ++i;
          }
        })();
      }
    });

    vm._xLabels = vm.chart
      .svg()
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0,0)")
      .selectAll(".tick")
      .data(vm._config.xCategories)
      .enter()
      .append("g")
      .attr("class", "tick")
      .attr("transform", function(d, i) {
        return (
          "translate(" +
          (i * vm._gridWidth + vm._gridWidth / 2) +
          "," +
          (vm._config.yCategories.length * vm._gridHeight + 20) +
          ")"
        );
      })
      .append("text")
      .attr("text-anchor", "middle")
      .text(function(d) {
        return d;
      });

    var biggestLabelWidth = d3.max(
      d3
        .select(".x.axis")
        .selectAll("text")
        .nodes()
        .map(function(o) {
          return o.getComputedTextLength();
        })
    ); // Biggest label computed text length
    var xBandWidth = vm._gridWidth;
    var labelMaxWidth = xBandWidth;
    if (biggestLabelWidth > xBandWidth) {
      // Biggest label doesn't fit
      vm._xLabels.each(function(d) {
        var _this2 = this;

        d3.select(this)
          .attr("text-anchor", "end")
          .attr("dy", 0)
          .attr("transform", "translate(-5,-10)rotate(-90)");
        // Still doesn't fit!
        labelMaxWidth = 0.75 * vm._config.size.margin.bottom;
        if (this.getComputedTextLength() > labelMaxWidth) {
          (function() {
            d3.select(_this2)
              .on("mouseover", axesTip.show)
              .on("mouseout", axesTip.hide);
            var i = 1;
            while (_this2.getComputedTextLength() > labelMaxWidth) {
              d3.select(_this2)
                .text(function(d) {
                  return d.slice(0, -i) + "...";
                })
                .attr("title", d);
              ++i;
            }
          })();
        } else {
          return d;
        }
      });
    }

    var maxRange;
    maxRange = d3.max(vm._data, function(d) {
      return d.value;
    });

    vm._scales.color = d3
      .scaleQuantile()
      .domain([0, maxRange])
      .range(vm._config.colors);

    var cards = vm.chart
      .svg()
      .selectAll(".grid-cell")
      .data(vm._data, function(d) {
        return d.y + ":" + d.x;
      });

    cards
      .enter()
      .append("rect")
      .attr("x", function(d) {
        return vm._config.xCategories.indexOf(String(d.x)) * vm._gridWidth;
      })
      .attr("y", function(d) {
        return vm._config.yCategories.indexOf(String(d.y)) * vm._gridHeight;
      })
      .attr("rx", vm._config.borderRadius || 5)
      .attr("ry", vm._config.borderRadius || 5)
      .attr("class", "grid-cell")
      .attr("stroke", "#fff")
      .attr("stroke-width", "3px")
      .attr("id", function(d) {
        return "x" + d.x + "y" + d.y;
      })
      .attr("width", vm._gridWidth)
      .attr("height", vm._gridHeight)
      .on("mouseover", function(d, i) {
        vm._tip.show(d, d3.select(this).node());
        if (vm._config.hasOwnProperty("mouseover")) {
          vm._config.mouseover.call(vm, d, i);
        }
      })
      .on("mouseout", function(d, i) {
        vm._tip.hide(d, d3.select(this).node());
        if (vm._config.hasOwnProperty("mouseout")) {
          vm._config.mouseout.call(this, d, i);
        }
      })
      .on("click", function(d, i) {
        if (vm._config.hasOwnProperty("onclick")) {
          vm._config.onclick.call(this, d, i);
        }
      })
      .attr("fill", vm._config.colors[0])
      .transition()
      .duration(3000)
      .ease(d3.easeLinear)
      .attr("fill", function(d) {
        return vm._scales.color(d.value);
      });

    if (vm._config.hasOwnProperty("legendTitle")) {
      Heatmap.drawColorLegend();
    }

    return vm;
  };

  Heatmap.init(config);

  return Heatmap;
}

var chartmodule = new chartModule();

export default chartmodule;
